import React from "react";
import withRouter from "../../custom/withRouter";
import ApplicationListViewTable from "../../custom/ApplicatoinListView";
import { FormLabel, Offcanvas } from "react-bootstrap";
import { TextField, InputAdornment } from "@mui/material";
import {
  deleteMappedUser,
  getApplicationLicenseStatus,
  auditLog,
  getApplicationUsers,
  licensePurchase,
  userRoleAssign,
  userRemoveTable,
  unAssignedUsers,
  roleBasedUsers,
  validationCheck,
  getApplication,
  allApplication,
  mapUser,
  purchaseLicense,
  allSubscribeApplication,
  userRoleAssignMultiple,
} from "../../../action/ApplicationApi";
import $, { data } from "jquery";
import Actions from "../../../action/api";
import API from "../../helpers/endpointservice";
import moment from "moment";
import { connect } from "react-redux";
import CommonIcon from "../../helpers/icons";
import { toast, ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import Box from "@mui/material/Box";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Autocomplete,
  Paper,
  Divider,
} from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import SubscriptionListViewTable from "../../custom/SubscriptionListView";
import { Email, Sort } from "@mui/icons-material";
import HistoryLogListView from "../../custom/HistorylogListView";
import { useLocation } from "react-router";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Backdrop,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import CancelSubscription from "./cancelSubscription";
import { successAlert } from "../../helpers/alert";
import Swal from "sweetalert2";
import CustomListView from "../MUIDataTable/CustomListView";
import CustomListViewSub from "../MUIDataTable/ListViewSub";
class subscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      teamError: false,
      isMultipleRoles: false,
      selectedRoleCheck: [],
      userError: false,
      isWebMobile: false,
      rolebasedId: "",
      expiryDate: "",
      temprolebasedId: "",
      tempRoleName: "",
      search: false,
      isMobile: false,
      isCancelScreenOpen: false,
      appDetails: null,
      isFilterApplied: false,

      assignedLicenses: 0,
      apprefernceid: 0,
      applicationroles: [],
      unAssignedUsers: [],
      unAssignedRoles: [],
      teamsData: [],
      pageSize: 0,
      pageIndex: 10,
      columnFilter: [],
      sortingFilters: [],
      selectedteam: null,
      applicationId: 0,
      applicationname: "",
      daysToExpire: "",
      subscriptionStatus: "",
      isAllowToRemoveLicense: true,
      totalLicense: 0,
      availableLicense: 0,
      checkedUser: false,
      handleChangeTable: 1,
      userorgroup: "",
      cancellationReason: [],
      cancelMessage: "",
      showTable: false,
      // selectedUser: null,

      openmemberdelete: false,
      deletedValues: [],

      selectedUser: [],
      selectedUserEmails: [],
      selectedUserID: [],
      selectedGroup: [],
      selectedGroupId: [],
      selectedtype: [],
      selectedUserss: [],
      selectedUserssss: [],
      rolebasedtableuser: [],
      editTable: false,
      invalidLicense: false,
      mockTotallicense: 0,
      subscriptionTable: false,
      unsubscriptionTable: false,
      choosedProduct: "",
      admins: [],
      clientId: "",
      rolename: "",
      totalCount: 0,
      totalPages: 0,
      totalCount1: 0,
      totalPages1: 0,
      currentPage: 1,
      currentPage1: 1,
      searchInput: "",
      isTenantAdminCenter: false,
      filterProductDropdown: [],

      editLicense: false,
      buyLicense: false,
      choice: {
        application: [],
        subscriptionStatus: 0,
        purchasedDate: null,
        name: "",
        email: "",
        type: "",
        action: "",
        actionby: "",
        startDate: null,
        endDate: null,
      },
      filteredOptions: {
        application: [],
        subscriptionStatus: "",
      },
      columns: [
        {
          accessorKey: "name",
          header: "Name",
          muiFilterTextFieldProps: ({ column }) => {
            const value = column.getFilterValue() || "";

            return {
              helperText:
                value.trim().length > 0 && value.trim().length < 3
                  ? "Minimum 3 characters required"
                  : "",
              slotProps: {
                formHelperText: {
                  sx: {
                    marginTop: "1.5px",
                    marginLeft: 0,
                  },
                },
              },
            };
          },
        },
        {
          accessorKey: "email",
          header: "Email",
          Cell: ({ row }) => {
            const { email, isPrimaryEmail } = row.original;
            return (
              <div className="d-flex align-items-center gap-2">
                <span>{email}</span>
                {isPrimaryEmail && (
                  <span className="badge-fun">Super Admin</span>
                )}
              </div>
            );
          },
          muiFilterTextFieldProps: ({ column }) => {
            const value = column.getFilterValue() || "";

            return {
              helperText:
                value.trim().length > 0 && value.trim().length < 3
                  ? "Minimum 3 characters required"
                  : "",
              slotProps: {
                formHelperText: {
                  sx: {
                    marginTop: "1.5px",
                    marginLeft: 0,
                  },
                },
              },
            };
          },
        },
        {
          accessorKey: "action",
          header: "Action",
          minSize: 50,
          maxSize: 50,
          enableColumnActions: false,
          enableSorting: false,
          enableColumnFilter: false,
          muiTableHeadCellProps: {
            sx: {
              borderTop: "1px solid rgba(224, 224, 224, 1)",
              "& .Mui-TableHeadCell-Content-Labels": {
                paddingLeft: "0px",
                fontWeight: "400",
              },
            },
          },
          Cell: ({ cell, row }) => {
            return (
              <span
                className={`cursor-pointer ${
                  row.original.isPrimaryEmail ? "d-none" : ""
                }`}
                onClick={() => this.handleDelete(row.original)}
              >
                <CommonIcon fileName={"DeleteIcon"} />
              </span>
            );
          },
        },
      ],

      columnHeaders: [
        { key: "name", label: "Product", width: "20%" },
        { key: "purchasedQuantity", label: "Purchased Quantity", width: "10%" },
        { key: "assignedLicense", label: "Assigned Licenses", width: "10%" },
        {
          key: "subcriptionStatus",
          label: "Status",
          width: "15%",
        },
        { key: "purchaseDate", label: "Purchased Date", width: "15%" },
        { key: "invoices ", label: "Invoices", width: "20%" },
      ],
      columnHeadersRoles: [
        { key: "name", label: "Name", width: "20%" },
        { key: "email", label: "Email", width: "20%" },
        // { key: "type", label: "Type", width: "20%" },
        { key: "remove", label: "Action", width: "20%" },
      ],
      columnHeadersLogs: [
        { key: "action", label: "Action", width: "20%" },
        { key: "actionBy", label: "Action By", width: "20%" },
        { key: "description", label: "Description", width: "20%" },
        { key: "actionDate", label: "Date", width: "20%" },
      ],
      filters: {
        limit: 15,
        offset: 0,
        sortBy: "name",

        sortByhistory: "actionDate",
        sortByOrder: "asc",
        application: [],
        name: "",
        email: "",
        type: "",
        startDate: null,
        endDate: null,
        subscriptionStatus: "",
        expiryDate: null,
        pageNumber: 1,
        PageSize: 10,
        pageNumber1: 1,
        PageSize1: 10,
      },
      groupMemberCount: 0,
      collapsedGroups: {},
      filtered: {},
      showlicense: true,
      showroleuser: false,
      showsettings: false,
      showhistory: false,
      normalData: [],
      groupedData: {},
      groupedColumn: null,
      collapsedGroups: {},
      value: 1,
      logs: [],
      unAssigned: [],
      subscriptionStatus: "",
      subscriptionStartDate: "",
      trialstartDate: "",
      isSSO: false,
    };
    // this.firstFunction()
    // this.handleChangeTable = this.handleChangeTable.bind(this);
  }

  // firstFunction = () => {
  //     // const url = new URL(window.location.href);
  //     // const params = new URL(url.search);
  //     // const applicationId = params.get('appId')
  //     const location = useLocation();
  //     const queryParams = new URLSearchParams(location.search);
  //     const applicationId = queryParams.get('appId')
  //     console.log(applicationId);
  //     if (applicationId) {
  //         this.setState({
  //             // expiryDate: expiryDate,
  //             // clientId: clientId,
  //             apprefernceid: applicationId,
  //             // view: true,
  //             actionId: applicationId,
  //             editTable: false,
  //             editLicense: false,
  //             showsettings: false,
  //             showhistory: false,
  //             showlicense: false,
  //             showroleuser: true,
  //         }, async () => {
  //             await this.props.dispatch(getApplication(applicationId)).then(async (response) => {
  //                 console.log(response.data);
  //                 this.setState({
  //                     totalLicense: response.data.license.totalLicenses,
  //                     availableLicense: response.data.license.availableLicenses,
  //                     applicationname: response.data.name,
  //                     applicationId: response.data.applicationId,
  //                     applicationroles: response.data.roles,
  //                     assignedLicenses: response.data.license.assingedLicenses,
  //                     mockTotallicense: response.data.license.totalLicenses,
  //                 })
  //                 this.newFormShow();
  //                 const data = {
  //                     Name: '',
  //                     Email: '',
  //                     Type: '',
  //                     SortBy: '',
  //                     SortOrder: '',
  //                     PageNumber: 1,
  //                     PageSize: 10
  //                 };
  //                 this.setState((prev) => ({
  //                     filters: {
  //                         ...prev.filters,
  //                         pageNumber: 1,
  //                         PageSize: 10
  //                     }
  //                 }))
  //                 this.props.dispatch(roleBasedUsers(applicationId, response.data.roles[0].id, data)).then((res) => {
  //                     console.log(res);
  //                     this.setState({ rolebasedtableuser: res.data })
  //                     this.setState((prev) => ({
  //                         rolebasedId: response.data.roles[0].id, value: response.data.roles[0].id, rolename: response.data.roles[0].name, totalCount: res.pagination.totalCount, totalPages: res.pagination.totalPages, currentPage: res.pagination.currentPage, filter: {
  //                             ...prev.filters,
  //                             PageSize: res.pagination.pageSize,

  //                         }
  //                     }), () => {
  //                         console.log(this.state.filters.pageNumber, this.state.filters.PageSize, this.state.currentPage);

  //                     })
  //                 })
  //                 const data1 = {
  //                     Name: '',
  //                     Email: '',
  //                     Type: '',
  //                     SortBy: this.state.filters.sortByhistory,
  //                     SortOrder: '',
  //                     PageNumber: 1,
  //                     PageSize: 10
  //                 };

  //                 this.props.dispatch(auditLog(this.state.apprefernceid, data1)).then((res) => {
  //                     console.log(res.data, 'Audit Log');
  //                     this.setState((prev) => ({
  //                         logs: res.data, totalCount1: res.pagination.totalCount, totalPages1: res.pagination.totalPages, currentPage1: res.pagination.currentPage,
  //                         filters: {
  //                             ...prev.filters,
  //                             PageSize1: res.pagination.pageSize,
  //                         }
  //                     }), () => {
  //                         console.log(this.state.filters.PageSize1, 'dsfhhds');

  //                     })
  //                 })
  //                 this.props.dispatch(unAssignedUsers(applicationId)).then((res) => {
  //                     console.log(res.data);
  //                     this.setState({ unAssigned: res.data })

  //                 })
  //             })
  //         });
  //     }

  // }

  decryptText = async (cipherText, base64Key, base64Iv) => {
    try {
      // Convert URL-safe base64 → normal base64
      cipherText = cipherText.replace(/-/g, "+").replace(/_/g, "/");
      while (cipherText.length % 4 !== 0) cipherText += "=";

      const keyBytes = Uint8Array.from(atob(base64Key), (c) => c.charCodeAt(0));
      const ivBytes = Uint8Array.from(atob(base64Iv), (c) => c.charCodeAt(0));
      const encryptedBytes = Uint8Array.from(atob(cipherText), (c) =>
        c.charCodeAt(0)
      );

      // Import AES key
      const cryptoKey = await window.crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "AES-CBC" },
        false,
        ["decrypt"]
      );

      // Perform decryption
      const decryptedBuffer = await window.crypto.subtle.decrypt(
        { name: "AES-CBC", iv: ivBytes },
        cryptoKey,
        encryptedBytes
      );

      return new TextDecoder().decode(decryptedBuffer);
    } catch (error) {
      console.error("Decrypt failed:", error);
      return null;
    }
  };

  firstFunction = async () => {
    const { location, dispatch } = this.props;
    const queryParams = new URLSearchParams(location.search);
    const applicationId = queryParams.get("appId");

    console.log(applicationId);

    if (applicationId) {
      this.setState(
        {
          apprefernceid: applicationId,
          actionId: applicationId,
          editTable: false,
          editLicense: false,
          showsettings: false,
          showhistory: false,
          showlicense: false,
          showroleuser: true,
        },
        async () => {
          try {
            const response = await dispatch(getApplication(applicationId));
            console.log(response.data);
            this.setState({ appDetails: response.data });

            this.setState(
              {
                totalLicense: response.data.license.totalLicenses,
                availableLicense: response.data.license.availableLicenses,
                applicationname: response.data.name,
                applicationId: response.data.applicationId,
                applicationroles: response.data.roles,
                assignedLicenses: response.data.license.assingedLicenses,
                mockTotallicense: response.data.license.totalLicenses,
                subscriptionStatus:
                  response?.data?.purchaseInfo?.subscriptionStatus,
                daysToExpire: response?.data?.purchaseInfo?.daysToExpire,
                clientId: response.data.clientId,
                rolebasedId: response.data.roles[0].id,
                value: response.data.roles[0].id,
                rolename: response.data.roles[0].name,
                isTenantAdminCenter: response.data.isTenantAdminCenter,
                isMultipleRoles: response.data.isMultipleRoleApplicable,
              },
              async () => {
                this.newFormShow();

                const data = {
                  Name: "",
                  Email: "",
                  Type: "",
                  SortBy: "",
                  SortOrder: "",
                  PageNumber: 1,
                  PageSize: 10,
                };

                this.setState((prev) => ({
                  filters: {
                    ...prev.filters,
                    pageNumber: 1,
                    PageSize: 10,
                  },
                }));
                if (this.state.isWebMobile || this.state.isMobile) {
                  const roleUsersResponse = await dispatch(
                    roleBasedUsers(
                      applicationId,
                      response.data.roles[0].id,
                      data
                    )
                  );
                  console.log(roleUsersResponse);

                  this.setState(
                    (prev) => ({
                      rolebasedtableuser: roleUsersResponse.data,
                      rolebasedId: response.data.roles[0].id,
                      value: response.data.roles[0].id,
                      rolename: response.data.roles[0].name,
                      totalCount: roleUsersResponse.pagination.totalCount,
                      totalPages: roleUsersResponse.pagination.totalPages,
                      currentPage: roleUsersResponse.pagination.currentPage,
                      filter: {
                        ...prev.filters,
                        PageSize: roleUsersResponse.pagination.pageSize,
                      },
                    }),
                    () => {
                      console.log(
                        this.state.filters.pageNumber,
                        this.state.filters.PageSize,
                        this.state.currentPage
                      );
                    }
                  );
                }

                const auditLogData = {
                  Name: "",
                  Email: "",
                  Type: "",
                  SortBy: this.state.filters.sortByhistory,
                  SortOrder: "",
                  PageNumber: 1,
                  PageSize: 10,
                };

                const auditLogResponse = await dispatch(
                  auditLog(this.state.apprefernceid, auditLogData)
                );
                console.log(auditLogResponse.data, "Audit Log");

                this.setState(
                  (prev) => ({
                    logs: auditLogResponse.data,
                    totalCount1: auditLogResponse.pagination.totalCount,
                    totalPages1: auditLogResponse.pagination.totalPages,
                    currentPage1: auditLogResponse.pagination.currentPage,
                    filters: {
                      ...prev.filters,
                      PageSize1: auditLogResponse.pagination.pageSize,
                    },
                  }),
                  () => {
                    console.log(this.state.filters.PageSize1, "dsfhhds");
                  }
                );

                const unAssignedUsersResponse = await dispatch(
                  unAssignedUsers(applicationId,response.data.isMultipleRoleApplicable)
                );
                console.log(unAssignedUsersResponse.data);
                this.setState({ unAssigned: unAssignedUsersResponse.data });
              }
            );
          } catch (error) {
            console.error("Error fetching data", error);
          }
        }
      );
    }
  };

  componentDidMount() {
    this.getIsSSO();
    this.firstFunction();
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    this.setState({
      filtered: data,
    });
    let tableLoader = false;
    this.getAllApplicationData(data);
    this.getCancellationRelease();
    const intervals = setInterval(() => {
      this.resize();
    }, 10);

    this.getAllApplicationFilterData();
    const encryptedValue =
      "FgXalaS3_uTsaWu315ykLCCGEGSwRJx3fYsPQKmtqzFAnRDbuB7AFFC5V4xfXOeQMjR8fNLvbba-je72pElFjd7UmNfvSrSJMWiV6Df6XwDfWhW0R0TZUBuBEQhHuWxbvX9YLBens38DqNDzMGwe6g";
    const key = "IYyH8SwPt5N1xbQ1bgmCQHuib7PZpyUZ0ccVQ3PmG+A=";
    const iv = "7k56c4nYGKPkrRS5WUvmsg==";

    this.decryptText(encryptedValue, key, iv).then((result) => {
      console.log("Decrypted:", result, JSON.parse(result));
    });
  }

  getIsSSO = () => {
    Actions.GET(API.IsSSO)
      .then((res) => {
        this.setState({ isSSO: res.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAllApplicationFilterData = () => {
    this.props
      .dispatch(allApplication({}))
      .then((response) => {
        console.log(response.data);
        this.setState({ filterProductDropdown: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCancellationRelease = () => {
    Actions.GET(API.cancellationReason)
      .then((res) => {
        if (res.data) {
          this.setState({ cancellationReason: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleScroll = () => {
    if (!this.state.isScroll) {
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoader: true,
          filtered: {
            ...prevState.filtered,
            offset: prevState.filtered.offset + 10,
          },
        }),
        () => {
          let tableLoader = true;
          this.getAllApplicationData(this.state.filtered, tableLoader);
        }
      );
    }
  };

  newFormShow = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("AddForm2")
    );
    this.setState({ showTable: true });
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({
      backdrop: true,
    });
  };

  getTeamsData = () => {
    this.setState({ teamsData: [] });
    Actions.GET(`${API.Teams}/All`)
      .then((res) => {
        if (res.data.data) {
          this.setState({ teamsData: res.data.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleEditId = (
    applicationId,
    clientId,
    expiryDate,
    status,
    trialstartDate,
    subscriptionStartDate
  ) => {
    console.log(expiryDate);

    this.setState(
      {
        expiryDate: expiryDate ? expiryDate : "",
        trialstartDate: trialstartDate ? trialstartDate : "",
        subscriptionStartDate: subscriptionStartDate
          ? subscriptionStartDate
          : "",
        clientId: clientId,
        apprefernceid: applicationId,
        view: true,
        actionId: applicationId,
        editTable: false,
        editLicense: false,
        showsettings: false,
        showhistory: false,
        showlicense: true,
        showroleuser: false,
        subscriptionStatus: status,
        rolebasedtableuser: [],
      },
      async () => {
        await this.props
          .dispatch(getApplication(applicationId))
          .then(async (response) => {
            console.log(response.data);
            this.setState({ appDetails: response.data });
            this.setState({
              totalLicense: response.data.license.totalLicenses,
              availableLicense: response.data.license.availableLicenses,
              applicationname: response.data.name,
              applicationId: response.data.applicationId,
              applicationroles: response.data.roles,
              assignedLicenses: response.data.license.assingedLicenses,
              mockTotallicense: response.data.license.totalLicenses,
              subscriptionStatus:
                response?.data?.purchaseInfo?.subscriptionStatus,
              daysToExpire: response?.data?.purchaseInfo?.daysToExpire,
              rolebasedId: response.data.roles[0].id,
              value: response.data.roles[0].id,
              rolename: response.data.roles[0].name,
              isTenantAdminCenter: response.data.isTenantAdminCenter,
              isMultipleRoles: response.data.isMultipleRoleApplicable,
            });
            this.newFormShow();
            const data = {
              Name: "",
              Email: "",
              Type: "",
              SortBy: "",
              SortOrder: "",
              PageNumber: 1,
              PageSize: 10,
            };
            this.setState((prev) => ({
              filters: {
                ...prev.filters,
                pageNumber: 1,
                PageSize: 10,
              },
            }));
            this.getTeamsData();
            if (this.state.isWebMobile || this.state.isMobile) {
              this.props
                .dispatch(
                  roleBasedUsers(applicationId, response.data.roles[0].id, data)
                )
                .then((res) => {
                  console.log(res);
                  this.setState({ rolebasedtableuser: res.data });
                  this.setState(
                    (prev) => ({
                      rolebasedId: response.data.roles[0].id,
                      value: response.data.roles[0].id,
                      rolename: response.data.roles[0].name,
                      totalCount: res.pagination.totalCount,
                      totalPages: res.pagination.totalPages,
                      currentPage: res.pagination.currentPage,
                      filter: {
                        ...prev.filters,
                        PageSize: res.pagination.pageSize,
                      },
                    }),
                    () => {
                      console.log(
                        this.state.filters.pageNumber,
                        this.state.filters.PageSize,
                        this.state.currentPage
                      );
                    }
                  );
                });
            }
            const data1 = {
              Name: "",
              Email: "",
              Type: "",
              SortBy: this.state.filters.sortByhistory,
              SortOrder: "",
              PageNumber: 1,
              PageSize: 10,
            };

            this.props
              .dispatch(auditLog(this.state.apprefernceid, data1))
              .then((res) => {
                console.log(res.data, "Audit Log");
                this.setState(
                  (prev) => ({
                    logs: res.data,
                    totalCount1: res.pagination.totalCount,
                    totalPages1: res.pagination.totalPages,
                    currentPage1: res.pagination.currentPage,
                    filters: {
                      ...prev.filters,
                      PageSize1: res.pagination.pageSize,
                    },
                  }),
                  () => {
                    console.log(this.state.filters.PageSize1, "dsfhhds");
                  }
                );
              });
            this.props
              .dispatch(
                unAssignedUsers(applicationId, response.data.isMultipleRoleApplicable)
              )
              .then((res) => {
                console.log(res.data);
                this.setState({ unAssigned: res.data });
              });
          });
      }
    );
  };
  customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };
  handleSort = (column) => {
    let { filters } = this.state;
    let sortByOrder = "asc";

    if (filters.sortBy === column && filters.sortByOrder === "asc") {
      sortByOrder = "desc";
    }

    var data = {
      sortBy: column,
      sortByOrder: sortByOrder,
      offset: 0,
      limit: 15,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
      purchasedDate: this.state.filters.purchasedDate,
    };
    this.state.groupedColumn = null;
    this.state.normalData = [];
    this.state.groupedData = {};
    this.state.filters.sortBy = column;
    this.state.filters.sortByOrder = sortByOrder;
    this.state.filtered = data;
    let tableLoader = true;
    this.getAllApplicationData(data, tableLoader);
  };

  handleSortRole = (column) => {
    let { filters } = this.state;
    let sortByOrder = "asc";

    if (filters.sortBy === column && filters.sortByOrder === "asc") {
      sortByOrder = "desc";
    }
    let data = {
      SortBy: column,
      SortOrder: sortByOrder,
      offset: 0,
      limit: 15,
      PageSize: this.state.filters.PageSize,
      PageNumber: this.state.filters.newPage,
    };
    this.state.groupedColumn = null;

    this.state.groupedData = {};
    this.state.filters.sortBy = column;
    this.state.filters.sortByOrder = sortByOrder;
    this.state.filtered = data;
    let tableLoader = true;
    this.props
      .dispatch(
        roleBasedUsers(this.state.apprefernceid, this.state.rolebasedId, data)
      )
      .then((res) => {
        // this.setState({ rolebasedtableuser: res.data })
        this.setState((prev) => ({
          rolebasedtableuser: res.data,
          totalCount: res.pagination.totalCount,
          totalPages: res.pagination.totalPages,
          currentPage: res.pagination.currentPage,
          filters: {
            ...prev.filters,
            PageSize: res.pagination.pageSize,
            pageNumber: res.pagination.pageNumber,
          },
        }));
      });
    // this.getAllApplicationData(data, tableLoader);
  };

  handleSortHistory = (column) => {
    let { filters } = this.state;
    let sortByOrder = "asc";

    if (filters.sortBy === column && filters.sortByOrder === "asc") {
      sortByOrder = "desc";
    }
    let data = {
      SortBy: column,
      SortOrder: sortByOrder,
      offset: 0,
      limit: 15,
      PageNumber: filters.pageNumber,
      PageSize: filters.PageSize,
    };
    this.state.groupedColumn = null;

    this.state.groupedData = {};
    this.state.filters.sortBy = column;
    this.state.filters.sortByOrder = sortByOrder;
    this.state.filtered = data;
    let tableLoader = true;
    this.props
      .dispatch(auditLog(this.state.apprefernceid, data))
      .then((res) => {
        this.setState({
          logs: res.data,
          totalCount1: res.pagination.totalCount,
          totalPages1: res.pagination.totalPages,
          currentPage1: res.pagination.currentPage,
        });
      });
  };
  resize = () => {
    if (window.innerWidth < 770) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  getAllApplicationData = (data, tableLoader, resetTableOrder = false) => {
    tableLoader
      ? this.setState({ isLoader: true })
      : this.setState({ isloading: true });
    this.props.dispatch(allSubscribeApplication(data)).then((response) => {
      console.log(response.data);
      this.processData(response.data, tableLoader, resetTableOrder);
    });
  };
  getAllApplicationData1 = (data, tableLoader, resetTableOrder = false) => {
    tableLoader
      ? this.setState({ isLoader: true })
      : this.setState({ isloading: true });
    this.props.dispatch(allSubscribeApplication(data)).then((response) => {
      console.log(response.data);
      this.processData1(response.data, tableLoader, resetTableOrder);
    });
  };
  processData = (result, tableLoader, resetTableOrder) => {
    const normalData = !resetTableOrder ? this.state.normalData || [] : [];
    const newData = [];
    console.log(result);

    if (Array.isArray(result)) {
      result.forEach((value) => {
        const applicationData = {
          ...value,
          purchasedDate: value.purchasedDate
            ? moment(value.purchasedDate).format("DD MMM YYYY")
            : "-",
        };
        // if (!normalData.some(x => x.applicationId === applicationData.applicationId)) {
        normalData.push(applicationData);
        // }
        newData.push(applicationData);
      });
    }
    console.log(normalData);
    const isValue = newData.length >= 10 ? false : true;
    this.setState({
      normalData: normalData,
      isLoader: false,
      isloading: false,
      isScroll: isValue,
    });
  };
  processData1 = (result, tableLoader, resetTableOrder) => {
    const normalData = [];
    const newData = [];
    console.log(result);

    if (Array.isArray(result)) {
      result.forEach((value) => {
        const applicationData = {
          ...value,
          purchasedDate: value.purchasedDate
            ? moment(value.purchasedDate).format("DD MMM YYYY")
            : "-",
        };
        // if (!normalData.some(x => x.applicationId === applicationData.applicationId)) {
        normalData.push(applicationData);
        // }
        newData.push(applicationData);
      });
    }
    console.log(normalData);
    const isValue = newData.length >= 10 ? false : true;
    this.setState({
      normalData: normalData,
      isLoader: false,
      isloading: false,
      isScroll: isValue,
    });
  };
  closeForm = () => {
    $("#AddForm1").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: "",
    };
    // this.getAllApplicationData(data, false, true)
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };
  closeForm1 = () => {
    $("#AddForm2").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: "",
    };
    this.getAllApplicationData(data, false, true);
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };
  closeFormCancel = () => {
    // $("#cancelsubscription").removeClass("show");
    // $(".offcanvas-backdrop").removeClass("show");
    // $("body").removeClass("scrollhide");
    // $(".main-content").removeClass("scrollhide");
    this.setState({
      isCancelScreenOpen: false,
    });
  };

  licenseshow = () => {};

  cancellicense = () => {
    this.setState({
      editLicense: false,
      invalidLicense: false,
      mockTotallicense: this.state.totalLicense,
    });
  };

  savelicense = async () => {
    console.log(this.state.totalLicense);
    await this.props
      .dispatch(
        licensePurchase(this.state.apprefernceid, this.state.mockTotallicense)
      )
      .then(async (res) => {
        console.log(res);
        this.setState({
          editLicense: false,
          invalidLicense: false,
          totalLicense: this.state.mockTotallicense,
        });
        this.customToast("License Updated");
        this.getApplication();
      });
  };
  handleIncrement = () => {
    // this.setState((prevState) => ({
    //   totalLicense: this.state.totalLicense + 1,
    //   invalidLicense:false,
    // }));
    this.setState((prevState) => ({
      mockTotallicense: this.state.mockTotallicense + 1,
      invalidLicense: false,
    }));
  };

  handleDecrement = () => {
    console.log(
      typeof this.state.assignedLicenses,
      typeof this.state.totalLicense
    );
    if (this.state.assignedLicenses < this.state.mockTotallicense) {
      this.setState((prevState) => ({
        mockTotallicense: Math.max(0, this.state.mockTotallicense - 1),
      }));
    } else {
      this.customToast("Remove users and then decrease the count");
      this.setState({ invalidLicense: true });
    }
  };
  newUserGroupFormShow = () => {
    const updatedId = [...this.state.selectedRoleCheck, this.state.rolename];
    console.log(updatedId);
    this.setState({
      teamError: false,
      userError: false,
      selectedteam: null,
      selectedUserEmails: [],
      tempRoleName: this.state.rolename,
      temprolebasedId: this.state.rolebasedId,
      selectedRoleCheck: updatedId,
    });

    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("AddGrouporrole")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({
      backdrop: true,
    });
  };

  closeFormRole = () => {
    if (this.state.temprolebasedId) {
      this.setState({
        // rolebasedId: this.state.temprolebasedId,
        temprolebasedId: "",
        selectedRoleCheck: [],
      });
    }
    if (this.state.tempRoleName) {
      this.setState({ rolename: this.state.tempRoleName, tempRoleName: "" });
    }
  };
  closeUserGroupForm = () => {
    $("#AddGrouporrole").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: "Subscribed",
    };
    // this.getAllApplicationData(data, false, true)
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      selectedteam: null,
      selectedUserssss: [],
      selectedUserEmails: [],
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };

  showlicense = () => {
    this.setState({
      showroleuser: false,
      showhistory: false,
      showsettings: false,
      showlicense: true,
    });
  };
  showrole = () => {
    this.setState({
      showroleuser: true,
      showhistory: false,
      showsettings: false,
      showlicense: false,
    });
  };
  showhistory = () => {
    this.setState({
      showroleuser: false,
      showhistory: true,
      showsettings: false,
      showlicense: false,
    });
  };
  showsettings = () => {
    this.setState({
      showroleuser: false,
      showhistory: false,
      showsettings: true,
      showlicense: false,
    });
  };

  handleUserChange = (event, newValue) => {
    console.log(newValue);

    if (newValue.length >= 0) {
      const selectedGroups = newValue.filter((user) => user.type === "group");
      const selectedUsers = newValue.filter((user) => user.type !== "group");

      const totalGroupMemberCount = selectedGroups.reduce(
        (acc, group) => acc + (group.groupMemberCount || 0),
        0
      );

      // Check if licenses are available for all selected users and groups
      if (
        this.state.availableLicense > 0 &&
        this.state.availableLicense >= totalGroupMemberCount
      ) {
        console.log("License available");

        // Use a Map to manage unique entries
        const existingEmails = new Map();
        const existingGroups = new Set();

        this.state.selectedUserEmails.forEach((email) =>
          existingEmails.set(email, true)
        );
        this.state.selectedGroup.forEach((group) => existingGroups.add(group));

        // New arrays to collect updates
        const newEmails = [];
        const newIDs = [];
        const newGroups = [];
        const newGroupIDs = [];
        const newTypes = [];

        newValue.forEach((user) => {
          if (user.type === "group") {
            console.log("Adding group:", user);
            newEmails.push(user.name); // Use the name for groups
            newIDs.push(user.id);
            newGroups.push(user.name);
            newGroupIDs.push(user.id);
            newTypes.push(user.type);

            // Update sets to include newly added items
            existingGroups.add(user.name);
          } else {
            console.log("Adding user:", user);
            newEmails.push(user.email);
            newIDs.push(user.id);
            newGroups.push(user.name); // Use the name for users
            newGroupIDs.push(user.id);
            newTypes.push(user.type);

            // Update maps to include newly added items
            existingEmails.set(user.email, true);
          }
        });

        // Update state with new values
        this.setState((prevState) => ({
          selectedUserEmails: [...newEmails],
          selectedUserID: [...newIDs],
          selectedGroup: [...newGroups],
          selectedGroupId: [...newGroupIDs],
          selectedtype: [...newTypes],
          selectedUserss: [...Array(newEmails.length).fill("")], // Adjust if needed
          selectedUserssss: newValue,
        }));
      } else {
        console.log("NOT AVAILABLE LICENSE");
        this.setState({ selectedUser: [] }); // Clear selection if licenses are not available
        this.customToast("License not available");
      }
    } else {
      this.setState({ selectedUser: [] }); // Clear selection if no users are selected
    }
  };

  toggleWebFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("FilterScreen1")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };

  applyFilterProducts = (id) => {
    const filtered = this.state.choice.application.filter(
      (item) => item.applicationId !== id
    );

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: filtered,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          application: filtered,
        },
        choice: {
          ...prevState.choice,
          application: filtered,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        this.applyFilterWoConditions();
      }
    );
  };

  closeWebFilter = () => {
    $("#FilterScreen1").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      choice: {
        application: [],
        subscriptionStatus: null,
        purchasedDate: null,
      },
    });
  };
  closeWebFilter1 = () => {
    $("#FilterScreen1").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
  };

  toggleWebFilterroles = () => {
    this.setState({
      search: true,
    });
  };
  closesearch = () => {
    this.setState({
      search: false,
      searchInput: "",
    });
    let data = {
      GenericSearch: "",
      Name: "",
      Email: "",
      Type: "",
      SortBy: "",
      SortOrder: "asc",
      PageNumber: 1,
      PageSize: 10,
    };
    this.props
      .dispatch(
        roleBasedUsers(this.state.apprefernceid, this.state.rolebasedId, data)
      )
      .then((res) => {
        console.log(res);
        this.setState((prev) => ({
          rolebasedtableuser: res.data,
          totalCount: res.pagination.totalCount,
          totalPages: res.pagination.totalPages,
          currentPage: res.pagination.currentPage,
          filters: {
            ...prev.filters,
            PageSize: res.pagination.pageSize,
            pageNumber: res.pagination.pageNumber,
          },
        }));
      });
  };
  toggleWebFilterhistory = () => {
    console.log("filter");
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("Filterscreenhistory")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };
  closeWebFilterhistory = () => {
    $("#Filterscreenhistory").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      choice: {
        application: [],
        subscriptionStatus: null,
        purchasedDate: null,
      },
    });
  };
  closeWebFilterroles = () => {
    $("#FilterScreenroles").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      choice: {
        application: [],
        subscriptionStatus: null,
        purchasedDate: null,
      },
    });
  };

  clearFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        choice: {
          ...prevState.choice,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: {
          sortBy: prevState.filters.sortBy,
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        filteredOptions: {
          application: [],
          subscriptionStatus: "",
        },
        isFilterApplied: false,
        isGroupBy: true,
      }),
      () => {
        const data = {
          sortBy: this.state.filters.sortBy,
          sortByOrder: this.state.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: this.state.filters.application,
          subscriptionStatus: "",
          purchasedDate: this.state.filters.purchasedDate,
        };

        this.getAllApplicationData(data, true);
        this.closeWebFilter();
      }
    );
  };

  applyFilter = () => {
    const { choice, filters } = this.state;

    // Convert purchasedDate to ISO format if it's not empty
    const purchasedDate = choice.purchasedDate
      ? new Date(choice.purchasedDate).toISOString()
      : null;

    const data = {
      sortBy: filters.sortBy,
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      application: choice.application,
      subscriptionStatus: choice.subscriptionStatus,
      purchasedDate: purchasedDate,
    };
    const shouldFilter =
      Array.isArray(data.application) && data.application.length > 0;
    console.log(data);
    if (shouldFilter) {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            application: choice.application,
            subscriptionStatus: choice.subscriptionStatus,
            purchasedDate: choice.purchasedDate,
          },
          filteredOptions: {
            ...prevState.filteredOptions,
            application: choice.application,
          },
          normalData: [],
          groupedData: {},
          groupedColumn: null,
          filtered: data,
          isGroupBy: true,
          tableLoader: true,
        }),
        () => {
          if (choice.application.length !== 0) {
            this.setState({ isFilterApplied: true });
          } else {
            this.setState({ isFilterApplied: false });
          }
          this.getAllApplicationData(data);
          this.closeWebFilter1();
        }
      );
    } else {
      this.customToast("Please provide filter value");
    }
  };
  applyFilterWoConditions = () => {
    const { choice, filters } = this.state;

    // Convert purchasedDate to ISO format if it's not empty
    const purchasedDate = choice.purchasedDate
      ? new Date(choice.purchasedDate).toISOString()
      : null;

    const data = {
      sortBy: filters.sortBy,
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      application: choice.application,
      subscriptionStatus: choice.subscriptionStatus,
      purchasedDate: purchasedDate,
    };
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: choice.application,
          subscriptionStatus: choice.subscriptionStatus,
          purchasedDate: choice.purchasedDate,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          application: choice.application,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        if (choice.application.length !== 0) {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }
        this.getAllApplicationData(data);
        this.closeWebFilter1();
      }
    );
  };
  clearRoleFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
          name: "",
          email: "",
          type: "",
        },
        choice: {
          ...prevState.choice,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
          name: "",
          email: "",
          type: "",
        },

        groupedData: {},
        groupedColumn: null,
        filtered: {
          sortBy: prevState.filters.sortBy,
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        isGroupBy: true,
      }),
      () => {
        const data = {
          Name: "",
          Email: "",
          Type: "",
          SortBy: "",
          SortOrder: "",
          PageNumber: "",
          PageSize: "",
        };

        this.props
          .dispatch(
            roleBasedUsers(
              this.state.apprefernceid,
              this.state.rolebasedId,
              data
            )
          )
          .then((res) => {
            this.setState({ rolebasedtableuser: res.data });
            this.closeWebFilterroles();
          });
      }
    );
  };
  clearHistoryFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
          name: "",
          email: "",
          type: "",
        },
        choice: {
          ...prevState.choice,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
          name: "",
          email: "",
          type: "",
          action: "",
          actionBy: "",
          startDate: null,
          endDate: null,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: {
          sortBy: prevState.filters.sortBy,
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        isGroupBy: true,
      }),
      () => {
        const data = {
          Name: "",
          Email: "",
          Type: "",
          SortBy: "",
          SortOrder: "",
          PageNumber: 1,
          PageSize: 10,
        };
        this.props
          .dispatch(auditLog(this.state.apprefernceid, data))
          .then((res) => {
            this.closeWebFilterhistory();
            this.setState({
              logs: res.data,
              totalCount1: res.pagination.totalCount,
              totalPages1: res.pagination.totalPages,
              currentPage1: res.pagination.currentPage,
            });
          });
      }
    );
  };
  applyRoleFilter = () => {
    const { choice, filters } = this.state;
    let data = {
      Name: choice.name,
      Email: choice.email,
      Type: choice.type,
      SortBy: filters.sortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: choice.application,
          subscriptionStatus: choice.subscriptionStatus,
          purchasedDate: choice.purchasedDate,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        this.props
          .dispatch(
            roleBasedUsers(
              this.state.apprefernceid,
              this.state.rolebasedId,
              data
            )
          )
          .then((res) => {
            this.setState((prev) => ({
              rolebasedtableuser: res.data,
              totalCount: res.pagination.totalCount,
              totalPages: res.pagination.totalPages,
              currentPage: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize: res.pagination.pageSize,
              },
            }));
            this.closeWebFilterroles();
          });
      }
    );
  };

  applyHistoryFilter = () => {
    const { choice, filters } = this.state;

    let data = {
      Action: choice.action,
      actionBy: choice.actionby,
      startDate: choice.startDate,
      endDate: choice.endDate,
      //    SortBy: filters.sortByhistory.toLowerCase(),
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: 10,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: choice.application,
          subscriptionStatus: choice.subscriptionStatus,
          purchasedDate: choice.purchasedDate,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        this.props
          .dispatch(auditLog(this.state.apprefernceid, data))
          .then((res) => {
            this.closeWebFilterhistory();
            this.setState({
              logs: res.data,
              totalCount1: res.pagination.totalCount,
              totalPages1: res.pagination.totalPages,
              currentPage1: res.pagination.currentPage,
              filters: {
                PageSize1: res.pagination.pageSize,
              },
            });
          });
      }
    );
  };

  lookupChange = (e, selectedValue, title) => {
    if (title === "application") {
      this.setState({
        choice: { ...this.state.choice, application: selectedValue },
      });
    }
    if (title === "subscriptionStatus") {
      if (selectedValue !== null) {
        this.setState({
          choice: {
            ...this.state.choice,
            subscriptionStatus: selectedValue.status,
          },
        });
      } else {
        this.setState({
          choice: { ...this.state.choice, subscriptionStatus: null },
        });
      }
    }
    if (title === "purchasedDate") {
      const formattedDate = new Date(e.target.value).toISOString();
      console.log(formattedDate);
      this.setState({
        choice: { ...this.state.choice, purchasedDate: e.target.value },
      });
    }
    if (title === "name") {
      console.log(e.target.value);

      this.setState({
        choice: { ...this.state.choice, name: e.target.value },
      });
    }
    if (title === "email") {
      this.setState({
        choice: { ...this.state.choice, email: e.target.value },
      });
    }
    if (title === "action") {
      console.log(e.target.value);

      this.setState({
        choice: { ...this.state.choice, action: e.target.value },
      });
    }
    if (title === "actionby") {
      this.setState({
        choice: { ...this.state.choice, actionby: e.target.value },
      });
    }
    if (title === "startdate") {
      this.setState({
        choice: { ...this.state.choice, startDate: e.target.value },
      });
    }
    if (title === "enddate") {
      this.setState({
        choice: { ...this.state.choice, endDate: e.target.value },
      });
    }
    if (title === "type") {
      console.log(e);

      this.setState({
        choice: { ...this.state.choice, type: selectedValue.status },
      });
    }
  };

  edittable = () => {
    this.setState({ editTable: !this.state.editTable });
  };
  handleCheckboxChange = (email, applicationRoleUserId) => {
    this.setState((prevState) => {
      const { selectedEmails } = prevState;
      if (selectedEmails.includes(applicationRoleUserId)) {
        return {
          selectedEmails: selectedEmails.filter(
            (e) => e !== applicationRoleUserId
          ),
        };
      } else {
        return { selectedEmails: [...selectedEmails, applicationRoleUserId] };
      }
    });
  };

  handleDataFetch = (pageSize, pageIndex, columnsFilters, sorting) => {
    this.setState({
      pageSize: pageSize,
      pageIndex: pageIndex,
      columnFilter: columnsFilters,
      sortingFilters: sorting,
    });

    const filterObject = columnsFilters.reduce((acc, curr) => {
      acc[curr.id] = curr.value;
      return acc;
    }, {});
    let sortorder = !sorting[0]?.desc;
    let data = {
      Name: filterObject.name
        ? filterObject.name?.trim().length >= 3
          ? filterObject.name?.trim()
          : ""
        : "",
      Email: filterObject.email
        ? filterObject.email?.trim().length >= 3
          ? filterObject.email?.trim()
          : ""
        : "",
      SortBy: sorting[0]?.id ?? "name",
      SortOrder: sortorder ? "asc" : "desc",
      PageNumber: pageSize + 1,
      PageSize: pageIndex,
    };

    console.log(data);
    this.getRoleData(data);
  };

  getRoleData = (data) => {
    this.setState({ tableLoader: true });
    this.props
      .dispatch(
        roleBasedUsers(this.state.apprefernceid, this.state.rolebasedId, data)
      )
      .then((res) => {
        console.log(res);
        this.setState({ rolebasedtableuser: res.data });
        this.setState(
          (prev) => ({
            totalCount: res.pagination.totalCount,
            totalPages: res.pagination.totalPages,
            currentPage: res.pagination.currentPage,
            filter: {
              ...prev.filters,
              PageSize: res.pagination.pageSize,
            },
          }),
          () => {
            console.log(
              this.state.filters.pageNumber,
              this.state.filters.PageSize,
              this.state.currentPage
            );
          }
        );
        this.setState({ tableLoader: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ tableLoader: false });
      });
  };
  getApplication = async () => {
    this.props
      .dispatch(validationCheck(this.state.apprefernceid))
      .then(async (response) => {
        console.log(response.data);
        this.setState({
          totalLicense: response.data.totalLicenses,
          availableLicense: response.data.availableLicenses,
          assignedLicenses: response.data.assingedLicenses,
          mockTotallicense: response.data.totalLicenses,
        });
      });
    let data = {
      Name: "",
      Email: "",
      Type: "",
      SortBy: "",
      SortOrder: "asc",
      PageNumber: this.state.filters.pageNumber,
      PageSize: this.state.filters.PageSize,
    };
    if (this.state.isWebMobile || this.state.isMobile) {
      this.props
        .dispatch(
          roleBasedUsers(this.state.apprefernceid, this.state.rolebasedId, data)
        )
        .then((res) => {
          console.log(res.pagination.pageSize);
          this.setState((prev) => ({
            rolebasedtableuser: res.data,
            totalCount: res.pagination.totalCount,
            totalPages: res.pagination.totalPages,
            currentPage: res.pagination.currentPage,
            filters: {
              ...prev.filters,
              PageSize: res.pagination.pageSize,
            },
          }));
        });
    } else {
      this.handleDataFetch(
        this.state.pageSize,
        this.state.pageIndex,
        this.state.columnFilter,
        this.state.sortingFilters
      );
    }
    this.props
      .dispatch(auditLog(this.state.apprefernceid, data))
      .then((res) => {
        console.log(res, "Audit Log");
        this.setState({
          logs: res.data,
          totalCount1: res.pagination.totalCount,
          totalPages1: res.pagination.totalPages,
          currentPage1: res.pagination.currentPage,
        });
      });
    this.props
      .dispatch(
        unAssignedUsers(this.state.apprefernceid, this.state.isMultipleRoles)
      )
      .then((res) => {
        console.log(res.data);
        this.setState({ unAssigned: res.data });
      });
  };

  cancel = () => {
    this.setState({
      selectedUserssss: [],
    });
  };
  savetable = () => {
    console.log("Selected user emails:", this.state.selectedUserEmails);
    console.log("Selected user IDs:", this.state.selectedUserID);

    let datas = this.state.selectedUserEmails.map((email, index) => ({
      client_id: this.state.clientId,
      roleName: this.state.rolename,
      email: email,
      userId: this.state.selectedUserID[index],
      groupName: this.state.selectedGroup[index] || "",
      type: this.state.selectedtype[index],
      groupId: this.state.selectedGroupId[index] || "",
    }));
    const isRadio = !this.state.isMultipleRoles;
    let roleNames = "";
    let roleId = "";
    let tempRoleNames = "";
    if (isRadio) {
      roleNames = this.state.rolename;
      tempRoleNames = this.state.rolename;
      roleId = this.state.temprolebasedId;
    } else {
      roleNames = this.state.selectedRoleCheck.join(",");
      tempRoleNames = this.state.selectedRoleCheck[0];
      roleId = this.state.applicationroles.find(
        (data) => data.name == this.state.selectedRoleCheck[0]
      )?.id;
    }
    console.log(roleNames);

    let data1 = {};
    if (!this.state.isSSO) {
      data1 = this.state.selectedUserssss.map((userData) => ({
        client_id: this.state.clientId,
        roleName: roleNames,
        email: userData.email,
        userId: userData.id,
        groupName: userData.name || "",
        type: userData.type,
        groupId: userData.id || "",
      }));
    } else {
      data1 = this.state.selectedUserssss.map((userData) => ({
        client_id: this.state.clientId,
        roleName: roleNames,
        email: userData.email,
        type: userData.type,
        firstName: userData.firstName,
        lastName: userData.lastName,
        managerEmail: userData.managerEmail || "",
      }));
    }

    console.log(data1);
    console.log(this.state.groupMemberCount);
    if (this.state.selectedUserEmails.length > 0) {
      this.setState({ userError: false, teamError: false });
      if (this.state.availableLicense > 0) {
        this.props.dispatch({ type: "IS_LOADER", data: true });
        this.props
          .dispatch(
            userRoleAssignMultiple(
              this.state.apprefernceid,
              this.state.temprolebasedId,
              data1,
              this.state.selectedteam?.teamId,
              this.state.isSSO
            )
            // userRoleAssign(
            //   this.state.apprefernceid,
            //   this.state.temprolebasedId,
            //   data1,
            //   this.state.selectedteam?.teamId,
            //   this.state.isSSO
            // )
          )
          .then((res) => {
            this.closeUserGroupForm();
            this.setState(
              {
                rolebasedId: roleId,
                temprolebasedId: "",
                tempRoleName: "",
                selectedRoleCheck: [],
                rolename: tempRoleNames,
              },
              () => {
                this.getApplication();
              }
            );

            let data = {
              sortBy: this.state.filters.sortBy,
              sortByOrder: this.state.filters.sortByOrder,
              pageNumber: this.state.filters.pageNumber,
              pageSize: this.state.filters.PageSize,
              application: this.state.filters.application,
              subscriptionStatus: this.state.filters.subscriptionStatus,
            };
            this.setState({
              filtered: data,
            });
            this.getAllApplicationData1(data);
            // Clear the selected users and reset the state after successful assignment
            this.setState({
              selectedUserEmails: [],
              selectedUserssss: [],
              selectedUserID: [],
              selectedGroup: [],
              selectedGroupId: [],
              selectedtype: [],
              selectedUser: [],
              editTable: false,
            });
            this.props.dispatch({ type: "IS_LOADER", data: false });
            this.customToast("User(s) added");
          })
          .catch((error) => {
            if (
              error.response.data.message.trim() ==
              "User assignment exceeds the available license count."
            ) {
              this.customToast(
                "User assignment exceeds the available license count"
              );
            }
            this.props.dispatch({ type: "IS_LOADER", data: false });
            console.log(error);
          });
      } else {
        this.customToast("Please check for license");
      }
    } else {
      if (this.state.selectedteam == null) {
        this.setState({ teamError: true });
      } else {
        this.setState({ teamError: false });
      }

      if (this.state.selectedUserEmails.length <= 0) {
        this.setState({ userError: true });
      } else {
        this.setState({ userError: false });
      }
    }
  };

  editapplicationrole = (rolebasedId) => {};

  cancelTrial = (data) => {
    let apiurl = `${API.DELETETRAIL}/${this.state.clientId}`;
    this.props.dispatch({ type: "IS_LOADER", data: true });
    Actions.DELETE(apiurl, data)
      .then((res) => {
        this.props.dispatch({ type: "IS_LOADER", data: false });
        this.closeFormCancel();
        this.closeForm1();
        this.successAlert12(this.formatAlertMessage(res.data.message));
      })
      .catch((error) => {
        this.props.dispatch({ type: "IS_LOADER", data: false });
        console.loh(error);
      });
  };

  allselect = (e) => {
    console.log(e);
    if (e) {
      console.log(this.state.rolebasedtableuser);
      this.state.rolebasedtableuser.map((e, i) => {
        this.setState((prevState) => ({
          selectedEmails: [
            ...prevState.selectedEmails,
            e.applicationRoleUserId,
          ],
        }));
      });
    } else {
      this.setState((prevState) => ({
        selectedEmails: [],
      }));
    }
  };

  formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // e.g., 'Jul'
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour to 12-hour format
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${day} ${month} ${year} `;
  };
  handleDelete = (value) => {
    console.log(value, "valueeeee");
    this.setState({ openmemberdelete: true });
    let data = [
      {
        client_id: this.state.clientId,
        roleName: this.state.rolename,
        email: value.email,
        userId: value.applicationRoleUserId
          ? value.applicationRoleUserId
          : value.id,
        groupName: value.name,
        type: value.type,
        groupId: value.id,
      },
    ];

    this.setState({ deletedValues: data });
    console.log(data);
  };

  yesActions = () => {
    this.setState({ openmemberdelete: false });
    console.log(this.state.deletedValues);
    this.props.dispatch({ type: "IS_LOADER", data: true });
    this.props
      .dispatch(
        userRemoveTable(
          this.state.apprefernceid,
          this.state.rolebasedId,
          this.state.deletedValues
        )
      )
      .then((res) => {
        this.setState({ selectedEmails: [] });
        let data = {
          sortBy: this.state.filters.sortBy,
          sortByOrder: this.state.filters.sortByOrder,
          pageNumber: this.state.filters.pageNumber,
          pageSize: this.state.filters.PageSize,
          application: this.state.filters.application,
          subscriptionStatus: this.state.filters.subscriptionStatus,
        };
        this.setState({
          filtered: data,
        });
        this.props.dispatch({ type: "IS_LOADER", data: false });
        this.getAllApplicationData1(data);
        this.getApplication();
        this.customToast("Deleted successfully");
      })
      .catch((error) => {
        console.log(error);
        this.props.dispatch({ type: "IS_LOADER", data: false });
      });
  };

  noActions = () => {
    this.setState({ openmemberdelete: false });
  };

  handlePagination = (newPage) => {
    console.log("New Page:", newPage);
    // this.state.filters.pageNumber=newPage;
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          // pageNumber: newPage
        },

        groupedData: {},
        groupedColumn: null,

        tableLoader: true,
      }),
      () => {
        let data = {
          PageSize: this.state.filters.PageSize,
          PageNumber: newPage,
        };
        this.props
          .dispatch(
            roleBasedUsers(
              this.state.apprefernceid,
              this.state.rolebasedId,
              data
            )
          )
          .then((res) => {
            console.log(res.pagination, "API SUCESS");

            this.setState({
              rolebasedtableuser: res.data,
              totalCount: res.pagination.totalCount,
              totalPages: res.pagination.totalPages,
              currentPage: res.pagination.currentPage,
              filters: {
                PageSize: res.pagination.pageSize,
              },
            });
          });
      }
    );
  };
  handlePaginationHistory = (newPage) => {
    console.log("New Page:", newPage);
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          // pageNumber: newPage
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        let data = {
          PageSize: this.state.filters.PageSize1,
          PageNumber: newPage,
        };
        this.props
          .dispatch(auditLog(this.state.apprefernceid, data))
          .then((res) => {
            this.setState((prev) => ({
              logs: res.data,
              totalCount1: res.pagination.totalCount,
              totalPages1: res.pagination.totalPages,
              currentPage1: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize1: res.pagination.pageSize,
              },
            }));
          });
      }
    );
  };

  handlePagePerPage = (value) => {
    console.log(value);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          PageSize: value,
        },

        groupedData: {},
        groupedColumn: null,
        tableLoader: true,
      }),
      () => {
        let data = {
          PageSize: value,
          PageNumber: this.state.filters.pageNumber,
        };
        this.props
          .dispatch(
            roleBasedUsers(
              this.state.apprefernceid,
              this.state.rolebasedId,
              data
            )
          )
          .then((res) => {
            this.setState((prev) => ({
              rolebasedtableuser: res.data,
              totalCount: res.pagination.totalCount,
              totalPages: res.pagination.totalPages,
              currentPage: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize: res.pagination.pageSize,
                pageNumber: res.pagination.pageNumber,
              },
            }));
          });
      }
    );
  };

  formatAlertMessage(message) {
    return message.replace(
      /\blink\b/i,
      '<a href="#" id="custom-link">link</a>'
    );
  }

  successAlert12(title) {
    Swal.fire({
      title: "",
      html: `<span class="popup-title">${title}</span>`,
      icon: "success",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
      customClass: {
        title: "popup-title",
        confirmButton: "buttonPopUpAction px-4",
      },
      didOpen: () => {
        const link = document.getElementById("custom-link");
        if (link) {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            const { navigate } = this.props;
            navigate(`/applications`);
            Swal.close();
          });
        }
      },
    });
  }

  handlePagePerPageHistory = (value) => {
    console.log(value);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          PageSize1: value,
        },

        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        let data = {
          PageSize: value,
          PageNumber: this.state.filters.pageNumber1,
        };
        this.props
          .dispatch(auditLog(this.state.apprefernceid, data))
          .then((res) => {
            this.setState((prev) => ({
              logs: res.data,
              totalCount1: res.pagination.totalCount,
              totalPages1: res.pagination.totalPages,
              currentPage1: res.pagination.currentPage,
              filters: {
                ...prev.filters,
                PageSize1: res.pagination.pageSize,
              },
            }));
          });
      }
    );
  };
  showmobilelicense = () => {
    console.log("filter");
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("showlicense")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };

  closemobilelicense = () => {
    $("#showlicense").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };
  showmobilerole = () => {
    // this.setState({ showroleuser: true, showhistory: false, showsettings: false, showlicense: false })
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("showroles")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };
  showmobilehistory = () => {
    // this.setState({ showroleuser: false, showhistory: true, showsettings: false, showlicense: false })
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("showhistory")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };
  showmobilesettings = () => {
    // this.setState({ showroleuser: false, showhistory: false, showsettings: true, showlicense: false })
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("showsettings")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };

  handleChangeTable = (event, newValue) => {
    console.log(newValue, "values");

    let data = {
      Name: "",
      Email: "",
      Type: "",
      SortBy: "",
      SortOrder: "asc",
      PageNumber: this.state.filters.pageNumber,
      PageSize: this.state.filters.PageSize,
    };
    const selectedRole1 = this.state.applicationroles.find(
      (role) => role.id === newValue
    );
    this.setState({ rolename: selectedRole1?.name });
    this.setState({ userorgroup: newValue, rolebasedId: newValue }, () => {
      if (this.state.isWebMobile || this.state.isMobile) {
        this.props
          .dispatch(roleBasedUsers(this.state.apprefernceid, newValue, data))
          .then((res) => {
            console.log(res.pagination);
            const selectedRole = this.state.applicationroles.find(
              (role) => role.id === newValue
            );
            console.log(selectedRole);
            this.setState(
              (prev) => ({
                rolebasedtableuser: res.data,
                rolebasedId: newValue,
                rolename: selectedRole?.name,
                currentPage: res.pagination.currentPage,
                totalPages: res.pagination.totalPages,
                totalCount: res.pagination.totalCount,
                filters: {
                  ...prev.filters,
                  PageSize: res.pagination.pageSize,
                },
              }),
              () => {
                console.log(
                  this.state.filters.PageSize,
                  "hjdghj",
                  this.state.currentPage,
                  this.state.totalPages,
                  this.state.totalCount
                );
              }
            );
          });
      } else {
        this.handleDataFetch(
          this.state.pageSize,
          this.state.pageIndex,
          this.state.columnFilter,
          this.state.sortingFilters
        );
      }
    });
    // this.props.dispatch(roleBasedUsers(this.state.apprefernceid, newValue, data)).then((res) => {

    //     console.log(res.pagination);
    //     const selectedRole = this.state.applicationroles.find((role) => role.id === newValue);

    //     this.setState((prev) => ({
    //         rolebasedtableuser: res.data, rolebasedId: newValue, rolename: selectedRole?.name, currentPage: res.pagination.currentPage, totalPages: res.pagination.totalPages, totalCount: res.pagination.totalCount, filters: {
    //             ...prev.filters,
    //             PageSize: res.pagination.pageSize,
    //         }
    //     }), () => {
    //         console.log(this.state.filters.PageSize, 'hjdghj', this.state.currentPage, this.state.totalPages, this.state.totalCount);
    //     })

    // })
  };
  cancelSubscription = () => {
    let istrial = this.state.subscriptionStatus == "Trial" ? true : false;
    let apiurl = `${API.getNotes}/${istrial}`;
    this.props.dispatch({ type: "IS_LOADER", data: true });
    Actions.GET(apiurl)
      .then((res) => {
        if (res.data) {
          this.setState({ cancelMessage: res.data });
        }
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("cancelsubscription")
        );
        this.setState({
          isCancelScreenOpen: true,
        });
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        $(".main-content").addClass("scrollhide");
        this.props.dispatch({ type: "IS_LOADER", data: false });
      })
      .catch((error) => {
        this.props.dispatch({ type: "IS_LOADER", data: false });
        console.log(error);
      });
  };
  filtersearch = () => {
    console.log(this.state.searchInput);
    let data = {
      Name: "",
      Email: "",
      Type: "",
      SortBy: "",
      SortOrder: "asc",
      PageNumber: 1,
      PageSize: 10,
      GenericSearch: this.state.searchInput,
    };
    this.props
      .dispatch(
        roleBasedUsers(this.state.apprefernceid, this.state.rolebasedId, data)
      )
      .then((res) => {
        console.log(res);
        this.setState((prev) => ({
          rolebasedtableuser: res.data,
          totalCount: res.pagination.totalCount,
          totalPages: res.pagination.totalPages,
          currentPage: res.pagination.currentPage,
          filters: {
            ...prev.filters,
            PageSize: res.pagination.pageSize,
            pageNumber: res.pagination.pageNumber,
          },
        }));
      });
  };

  handleRoleSelect = (selectedId) => {
    const selectedRole = this.state.applicationroles.find(
      (role) => role.id === selectedId
    );

    this.setState({
      temprolebasedId: selectedId,
      selectedteam:
        selectedRole?.name === "Admin" ? null : this.state.selectedteam,
      rolename: selectedRole?.name,
    });
  };

  render() {
    const { isWebMobile } = this.state;
    const isRadio = !this.state.isMultipleRoles; // or boolean flag

    return (
      <>
        {this.state.isWebMobile || this.state.isMobile ? (
          <>
            <Backdrop
              className="spinner-backdrop"
              open={this.props.userRoleAssign}
            >
              <CircularProgress color="primary" />
            </Backdrop>
            <div className="row">
              <ToastContainer />
              {/* <div className="col-12 titlebar-mob"> */}
              {this.state.isWebMobile && (
                <div className="row">
                  <div className="col-1 pe-0">
                    <span
                      className="mobile-menusub"
                      onClick={() => this.props.toggleMenu()}
                    >
                      <CommonIcon fileName={"Menu"} />
                    </span>
                  </div>
                  <div className="col-9 ps-3">
                    <span className="headerform-mobile">Subscriptions</span>
                  </div>
                  <div className="col-2 pt-1 ps-0 pe-0">
                    <button
                      className="btn-fun ps-3 pe-3"
                      type="button"
                      onClick={this.toggleWebFilter}
                    >
                      <CommonIcon
                        fileName={
                          this.state.isFilterApplied ? "Filtered" : "Filter"
                        }
                      />{" "}
                    </button>{" "}
                  </div>
                </div>
              )}
              {!this.state.isWebMobile && (
                <div className="row tapbar ps-0">
                  <div className="col-5 ">
                    <span className="headerform">Subscriptions</span>
                  </div>
                  <div className="col-lg-7 col-sm-7 col-md-7 col-lg-6 d-flex justify-content-end pe-0 pt-2 pr-5">
                    <div className="btn-container ">
                      <button
                        className=" btn-funfilter1  ps-3 pe-3"
                        type="button"
                        onClick={() => this.toggleWebFilter()}
                      >
                        <CommonIcon
                          fileName={
                            this.state.isFilterApplied ? "Filtered" : "Filter"
                          }
                        />
                      </button>{" "}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* content */}
            {this.state.isFilterApplied && (
              <>
                <div className="mt-3 mb-0" style={{ paddingRight: "2rem" }}>
                  {this.state.filteredOptions.application &&
                    this.state.filteredOptions.application.map((data) => (
                      <span className="filteredBadgeApp">
                        <span>{data?.name}</span>
                        <span
                          onClick={() => {
                            this.applyFilterProducts(data.applicationId);
                          }}
                          className="ms-2"
                        >
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    ))}
                </div>
                <p className="mb-0 mt-2 countValue">
                  Count: {this.state.normalData.length}
                </p>
              </>
            )}
            <div className="mt-4 wholecard pe-2">
              {!this.props.isLoading && this.state.normalData.length < 1 ? (
                <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 p-2">
                  <div className="card-body">
                    <div
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "-0.1px",
                        bottom: "-0.2px",
                        width: "4px",
                        backgroundColor: " rgb(33, 150, 243)",
                      }}
                    ></div>
                    <div className="row">
                      <div className="col-12 d-flex align-items-center">
                        <div className="row text-center w-100">
                          <div className="col-12">
                            <span
                              className="nofound "
                              style={{ fontWeight: "bold" }}
                            >
                              No records found
                            </span>
                          </div>
                          {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                this.state.normalData.map((element, inde) => {
                  return (
                    <div
                      className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 "
                      onClick={() =>
                        this.handleEditId(
                          element.id,
                          element.clientId,
                          element.trialExpiryDate,
                          element.subcriptionStatus,
                          element.trialStartDate,
                          element.subscriptionStartDate
                        )
                      }
                    >
                      <div className="card-body pt-0 pb-0">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: element.colorCode,
                          }}
                        ></div>
                        <div className="row">
                          <div className="col-12 d-flex align-items-center mb-1">
                            <div className="row">
                              <div className="col-12">
                                <span
                                  className="reporttext14"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {element.name}
                                </span>
                              </div>
                              {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                            </div>
                          </div>

                          <div className="col-6 d-flex align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">
                                  Purchased Quantity
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.purchasedQuantity}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">
                                  Assigned License
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.assignedLicense}
                                </span>
                              </div>
                            </div>
                          </div>

                          {element.subscriptionStartDate ? (
                            <div className="col-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">
                                    Purchased Date
                                  </span>
                                </div>

                                <div className="col-12">
                                  <span className="reporttext12 ">
                                    {this.formatDate(
                                      element.subscriptionStartDate
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {element.trialStartDate ? (
                            <div className="col-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">
                                    Trial Start Date
                                  </span>
                                </div>

                                <div className="col-12">
                                  <span className="reporttext12 ">
                                    {this.formatDate(element.trialStartDate)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="col-6 align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">Invoices</span>
                              </div>

                              <div className="col-12">
                                <span className="reporttext12 ">
                                  {element.purchasedDate}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* <div className="col-lg-1 col-md-1 col-4 col-sm-1 d-flex align-items-center justify-content-end">
                                                    <div className="row ">
                                                        <CommonIcon className="float-end" fileName={'Arrownext'} />
                                                    </div>
                                                </div> */}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            {/* license roles settings */}
            {/* <div
                                className="offcanvas offcanvas-end p-3 ps-2 pb-0 pt-0 pe-0"
                                data-bs-scroll="false"
                                data-bs-backdrop
                                id="AddForm2"
                                aria-labelledby="offcanvasScrollingLabel"
                                style={{
                                    width: "calc(100%)",
                                    height: '100vh',
                                }}
                            >
                                <>
                                    <div className='d-flex justify-content-between ps-1 pt-0'>
                                        <h3 className='headername3 pt-3 pb-0'>{this.state.applicationname}</h3>
                                        <button
                                            data-bs-dismiss="offcanvas"
                                            className="offcavasclose float-end "
                                            onClick={() => this.closeForm()}
                                        >
                                            <CommonIcon fileName={"Close"} />
                                        </button>
                                    </div>
                                    <div className='mb-2 ps-1'>
                                        <label className='pathlabel'>Subscriptions &gt;<span className='isblue'>{this.state.applicationname}</span></label>
                                    </div>
                                    <div className='mobileoverflowsub'>
                                        <div className='row ps-1'>
                                            <div className='col-12'>
                                                <h3 className='licenseheader'>Trial Licenses</h3>
                                            </div>
                                            <div className='col-12 pt-0'>
                                                <div className="col-12">
                                                    <FormLabel className="formlabel-style1">Licenses </FormLabel><br /><FormLabel className={`formlabel-input`}>{this.state.totalLicense}</FormLabel>
                                                </div>
                                                <div className="col-12">
                                                    <FormLabel className="formlabel-style1">Assigned </FormLabel><br /><FormLabel className={`formlabel-input`}>{this.state.assignedLicenses} / {this.state.totalLicense}</FormLabel>
                                                </div>

                                                <button className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2" >Assign Licenses</button>
                                                <button className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2" >Start a paid subscription now</button>

                                            </div>
                                        </div>
                                        <hr className='hrproducts' />
                                        <div className='row ps-1'>
                                            <div className='col-12'>
                                                <h3 className='licenseheader'>Subscription</h3>
                                            </div>
                                            <div className='col-12 pt-0'>
                                                <div className="col-12">
                                                    <FormLabel className="formlabel-style1">Status</FormLabel><br /><FormLabel className={`formlabel-input12 ${(this.state.subscriptionStatus == "Subscribed" || this.state.subscriptionStatus == "Trial") ? "text-success" : " reporttext12un"} `}>{"Active"}</FormLabel>
                                                </div>
                                                <button className="btn-cancel1 btn-filter-action border-none mt-0 isred ms-0 ps-0 d-flex justify-content-start" onClick={this.cancelSubscription}>Cancel Trial</button>

                                            </div>
                                        </div>
                                        <hr className='hrproducts' />
                                        <div className='row ps-1'>
                                            <div className='col-12'>
                                                <h3 className='licenseheader'>Licensed users</h3>
                                            </div>
                                            <div className='col-12'>
                                                <div className="container-fluid">
                                                    <div className="row ps-1">

                                                        <div className="col-12 col-md-8 ps-0">
                                                            <Box sx={{ width: '100%', paddingLeft: 0 }}>
                                                                <div className="d-flex float-end mobiletab">
                                                                    <Tabs
                                                                        value={this.state.rolebasedId}
                                                                        onChange={this.handleChangeTable}
                                                                        aria-label="basic tabs example"
                                                                        variant="scrollable"
                                                                        scrollButtons="auto"
                                                                        allowScrollButtonsMobile
                                                                    >
                                                                        {this.state.applicationroles.map((e) => (
                                                                            <Tab
                                                                                key={e.id}
                                                                                label={e.name}
                                                                                value={e.id}
                                                                                sx={{ textTransform: 'none' }}
                                                                                className="m1 p0 mr-20"
                                                                            />
                                                                        ))}
                                                                    </Tabs>
                                                                    <div className="d-none d-md-flex align-items-center ms-2">
                                                                        <div className="d-flex align-items-center">
                                                                            {!this.state.search && (
                                                                                <button className="btn-fun ps-2 p-2 pe-2 fs-7 me-2" onClick={this.toggleWebFilterroles}>
                                                                                    <CommonIcon fileName={'Filter'} />
                                                                                </button>
                                                                            )}
                                                                            {this.state.search && (
                                                                                <div className="border d-flex align-items-center me-2">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="pt-1 pb-2 border-0 outline-none p-1"
                                                                                        value={this.state.searchInput}
                                                                                        onChange={(e) => this.setState({ searchInput: e.target.value })}
                                                                                    />
                                                                                    <span onClick={this.closesearch} className="ms-2">
                                                                                        <CommonIcon fileName={'close'} />
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                            {this.state.search && (
                                                                                <button className="btn-fun ps-3 p-2 pe-3 fs-7" onClick={this.filtersearch}>
                                                                                    Search
                                                                                </button>
                                                                            )}
                                                                            {!this.state.search && (
                                                                                <button className="btn-fun ps-3 p-2 pe-3 fs-7 ms-2" onClick={this.newUserGroupFormShow}>
                                                                                    + Add
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Box>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12 me-4 mt-2'>
                                                <div className='float-end d-flex me-2'>
                                                    {!this.state.search ? <button className="btn-fun ps-2 p-2 pe-2 fs-7" onClick={this.toggleWebFilterroles}><CommonIcon fileName={'Filter'} /></button> : ""}
                                                    {this.state.search ? <div className='border me-1 d-flex'><input type='text' className=' pt-1 pb-2 border-none outlineno p-1' onChange={(e) => this.setState({ searchInput: e.target.value, })} /><span onClick={this.closesearch}><CommonIcon fileName={'close'} /></span></div> : ""}
                                                    {this.state.search ? <button className="btn-fun ps-3 p-2 pe-3 fs-7 " onClick={this.filtersearch}>Search</button> : ""}
                                                    {!this.state.search ? <button className="btn-fun ps-3 p-2 pe-3 fs-7 " onClick={this.newUserGroupFormShow}>+ Add</button> : ""}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row ps-2 mt-2 overflowsubmembers pe-2'>
                                            {!this.props.isLoading && this.state.rolebasedtableuser.length < 1 ?
                                                <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 p-2" style={{ width: "94%" }} >
                                                    <div className="card-body">
                                                        <div style={{ position: 'absolute', left: '0', top: '-0.1px', bottom: '-0.2px', width: '4px', backgroundColor: " rgb(33, 150, 243)" }}>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12 d-flex align-items-center">
                                                                <div className="row text-center w-100">
                                                                    <div className="col-12"><span className="nofound " style={{ fontWeight: "bold" }}>No records found</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> :

                                                this.state.rolebasedtableuser.map((element) => {
                                                    console.log(element);

                                                    return (
                                                        <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 pb-3" style={{ width: "94%", height: '120px' }}>
                                                            <div className="card-body pt-0 pb-0">
                                                                <div style={{ position: 'absolute', left: '0', top: '-0.1px', bottom: '-0.2px', width: '4px', backgroundColor: " rgb(33, 150, 243)" }}>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-12 d-flex align-items-center mb-1">
                                                                        <div className="row">
                                                                            <div className="col-12"><span className="reporttext14" style={{ fontWeight: "bold" }}>{element.name}</span></div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6 d-flex align-items-center">
                                                                        <div className="row ">
                                                                            <div className="col-12"><span className="reporttext14" >Email</span></div>
                                                                            <div className="col-12"><span className="reporttext12" >{element.email}</span></div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6 d-flex align-items-center justify-content-end ">

                                                                        <span className='float-end' onClick={() => this.handleDelete(element)}><CommonIcon fileName={'DeleteIcon'} /></span>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                        </div>

                                    </div>
                                </>

                            </div> */}

            {/* filter offcanvas */}
            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreen1"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilter1()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <Autocomplete
                        multiple
                        id="roleId"
                        className="Multiprod"
                        disablePortal
                        variant="filled"
                        options={this.state.filterProductDropdown}
                        isOptionEqualToValue={(option, value) =>
                          option.applicationId === value.applicationId
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={this.state.choice?.application || []}
                        onChange={(e, selectedValues) => {
                          const mapped = selectedValues.map((item) => ({
                            clientId: item.clientId,
                            applicationId: item.applicationId,
                            name: item.name,
                            colorCode: item.colorCode,
                          }));
                          this.lookupChange(e, mapped, "application");
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            className="filter_input Multiprod"
                            focused
                            label="Applications"
                            InputLabelProps={{
                              shrink: true, // force label to float up always
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                paddingTop: "30px", // space for label
                                alignItems: "flex-start",
                                flexWrap: "wrap",
                                minHeight: "64px",
                              },
                              "& .MuiInputLabel-root": {
                                top: "10px", // adjust label position if needed
                              },
                              "& .MuiChip-root": {
                                margin: "2px",
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20 ">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreenroles"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilterroles()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Name"
                        variant="filled"
                        value={this.state.choice.name}
                        onChange={(e) => this.lookupChange(e, "", "name")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Email"
                        variant="filled"
                        value={this.state.choice.email}
                        onChange={(e) => this.lookupChange(e, "", "email")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <Autocomplete
                        focused
                        id="roleId"
                        variant="filled"
                        disablePortal
                        value={
                          this.state.choice.type
                            ? { status: this.state.choice.type }
                            : null
                        }
                        options={[
                          { id: "1", status: "group" },
                          { id: "2", status: "user" },
                        ]}
                        getOptionLabel={(option) => option.status || ""}
                        onChange={(e, selectedValue) =>
                          this.lookupChange(e, selectedValue, "type")
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.id}>
                            {option.status}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            className="filter_input"
                            focused
                            label="Type"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20 ">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearRoleFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyRoleFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="Filterscreenhistory"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilterhistory()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Action"
                        variant="filled"
                        value={this.state.choice.action}
                        onChange={(e) => this.lookupChange(e, "", "action")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Action By"
                        variant="filled"
                        value={this.state.choice.actionby}
                        onChange={(e) => this.lookupChange(e, "", "actionby")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        type="date"
                        id="jobOpOpenPositions"
                        fullWidth
                        label="Start Date"
                        className="filter_input"
                        variant="filled"
                        value={this.state.choice.startDate || ""}
                        onChange={(e) => this.lookupChange(e, "", "startdate")}
                        focused
                        disablePortal
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        type="date"
                        id="jobOpOpenPositions"
                        fullWidth
                        label="End Date"
                        className="filter_input"
                        variant="filled"
                        value={this.state.choice.endDate || ""}
                        onChange={(e) => this.lookupChange(e, "", "enddate")}
                        focused
                        disablePortal
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20 ">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearHistoryFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyHistoryFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className={`modal modal-style ${
                this.state.openmemberdelete ? "show" : ""
              }`}
              id="deletemodal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{
                display: this.state.openmemberdelete ? "block" : "none",
                zIndex: "1070",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <CommonIcon fileName={"deletemember"} />
                    <br />
                    <span>Are you sure, you want to delete this user?</span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noActions()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesActions()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end ps-2"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="showlicense"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className="d-flex justify-content-between ps-1 pt-0">
                <h3 className="headername3 pt-3 ps-2">Licenses</h3>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose float-end "
                  onClick={() => this.closeForm()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>
              <div className="ps-2">
                <label>
                  Subscriptions &gt;{this.state.applicationname}&gt;
                  <span className="isblue">Licenses</span>
                </label>
              </div>
              <div className="row p-4 ps-2 pt-2 mt-1">
                <div className="col-12">
                  <div className="col-12 d-flex ">
                    <div className="col-10">
                      <FormLabel className="formlabel-style1">
                        Total license count{" "}
                      </FormLabel>
                      <span
                        className={`formlabel-input mt--9 ${
                          !this.state.editLicense ? "d-block" : "d-none"
                        }`}
                      >
                        {this.state.totalLicense}
                      </span>
                      <div
                        className={`${
                          this.state.editLicense ? "d-flex" : "d-none"
                        } flex-wrap mt-1  align-items-start`}
                        id="licenseinput"
                      >
                        <TextField
                          className="number-field-1 mb-2"
                          value={this.state.mockTotallicense}
                          onChange={this.handleChange}
                          InputProps={{
                            inputProps: { min: 0 },
                            endAdornment: (
                              <InputAdornment position="end">
                                <div className="adornment-container">
                                  <div
                                    onClick={this.handleIncrement}
                                    className="cursor-pointer "
                                  >
                                    <CommonIcon fileName={"ArrowUpIcon"} />
                                  </div>
                                  <div
                                    onClick={() => this.handleDecrement()}
                                    className="cursor-pointer "
                                  >
                                    <CommonIcon fileName={"ArrowDownIcon"} />
                                  </div>
                                </div>
                              </InputAdornment>
                            ),
                          }}
                        />

                        {this.state.invalidLicense ? (
                          <label className="isrequired invalidlabel">
                            All license are assigned to users.
                          </label>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="col-2">
                      <span
                        className="editlicensemobile cursor-pointer"
                        onClick={() =>
                          this.setState({
                            editLicense: !this.state.editLicense,
                          })
                        }
                      >
                        {this.state.editLicense ? (
                          ""
                        ) : (
                          <CommonIcon fileName={"editicon"} />
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="col-12  mt-3">
                    {/* <div className='d-flex'><FormLabel className="formlabel-style1">Available license count &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;</FormLabel> <span className={`formlabel-input mt--9 `}>{this.state.availableLicense}</span></div> */}
                    <FormLabel className="formlabel-style1 w-100">
                      Available license count
                    </FormLabel>
                    <FormLabel className="formlabel-input w-100">
                      {" "}
                      {this.state.availableLicense}
                    </FormLabel>
                  </div>

                  {this.state.subscriptionStartDate ? (
                    <div className="col-12 mt-3 ">
                      {/* <div className='d-flex'><FormLabel className="formlabel-style1">Purchased Date &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;</FormLabel> <span className={`formlabel-input mt--9 `}>{this.formatDate(this.state.subscriptionStartDate)}</span></div> */}
                      <FormLabel className="formlabel-style1 w-100">
                        Purchased Date
                      </FormLabel>
                      <FormLabel className="formlabel-input w-100">
                        {this.formatDate(this.state.subscriptionStartDate)}
                      </FormLabel>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.trialstartDate ? (
                    <div className="col-12 mt-3 ">
                      {/* <div className='d-flex'><FormLabel className="formlabel-style1">Trial Started Date &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;</FormLabel> <span className={`formlabel-input mt--9 `}>{this.formatDate(this.state.trialstartDate)}</span></div> */}

                      <FormLabel className="formlabel-style1 w-100">
                        Trial Started Date
                      </FormLabel>
                      <FormLabel className="formlabel-input w-100">
                        {this.formatDate(this.state.trialstartDate)}
                      </FormLabel>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.expiryDate ? (
                    <div className="col-12 mt-3 ">
                      {/* <div className='d-flex'><FormLabel className="formlabel-style1">Expiry Date &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;</FormLabel> <span className={`formlabel-input mt--9 `}>{this.formatDate(this.state.expiryDate)}</span></div> */}

                      <FormLabel className="formlabel-style1 w-100">
                        Expiry Date
                      </FormLabel>
                      <FormLabel className="formlabel-input w-100">
                        {this.formatDate(this.state.expiryDate)}
                      </FormLabel>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <div className="mt-2">
                                                <button className="ms-1 closelicense border-none ms-2" onClick={() => this.cancellicense()}><CommonIcon fileName={'close'} /></button>
                                                <button className="ms-1 savelicense border-none ms-2" onClick={this.savelicense}><CommonIcon fileName={'saveicon'} /></button>

                                            </div> */}
                  {this.state.editLicense ? (
                    <div className="mt-3">
                      <button
                        className="btn-clear p-2 mr-10 border-none"
                        onClick={() => this.cancellicense()}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn-fun ms-2 ps-3 p-2 pe-3 fs-7"
                        onClick={this.savelicense}
                      >
                        Update
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className='col-2'>
                                <span className="editlicense cursor-pointer" onClick={() => this.setState({ editLicense: !this.state.editLicense })}>{this.state.editLicense ? "" : <CommonIcon fileName={'editicon'} />}</span>
                            </div> */}
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end ps-2"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="showroles"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className="d-flex justify-content-between ps-1 pt-0">
                <h3 className="headername3 pt-3 ps-2">Roles</h3>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose float-end "
                  onClick={() => this.closeForm()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>
              <div className="ps-2">
                <label>
                  Subscriptions &gt;{this.state.applicationname}&gt;
                  <span className="isblue">Roles</span>
                </label>
              </div>
              <div className="row p-4 ps-2 pt-2 mt-1">
                <div className="roleslabelmobile">
                  {this.state.applicationroles.map((e, i) => {
                    return (
                      <div onClick={() => this.handleChangetabs(e)}>
                        <label
                          className={` ${
                            this.state.value == e.id
                              ? "rolenamesmobile"
                              : "rolenamesmobileun"
                          }`}
                        >
                          {e.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div>
            <div className="w-100 pr">
              <div className="row tapbar" style={{ paddingRight: "2rem" }}>
                <div className="col-5 ">
                  <span className="headerform">Subscriptions</span>
                </div>
                <div className="col-lg-7 col-sm-7 col-md-7 col-lg-6 d-flex justify-content-end pe-2  pt-2">
                  <div className="">
                    <button
                      className=" btn-funfilter1  ps-3 pe-3"
                      type="button"
                      onClick={() => this.toggleWebFilter()}
                    >
                      <CommonIcon
                        fileName={
                          this.state.isFilterApplied ? "Filtered" : "Filter"
                        }
                      />
                    </button>{" "}
                  </div>
                </div>
              </div>
            </div>
            {this.state.isFilterApplied && (
              <>
                <div className="mt-3 mb-0" style={{ paddingRight: "2rem" }}>
                  {this.state.filteredOptions.application &&
                    this.state.filteredOptions.application.map((data) => (
                      <span className="filteredBadgeApp">
                        <span>{data?.name}</span>
                        <span
                          onClick={() => {
                            this.applyFilterProducts(data.applicationId);
                          }}
                          className="ms-2"
                        >
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    ))}
                </div>
                <p className="mb-0 mt-2 countValue">
                  Count: {this.state.normalData.length}
                </p>
              </>
            )}
            <div className="mt-3 wholecard " style={{ marginRight: "2rem" }}>
              {!this.props.isLoading && this.state.normalData.length < 1 ? (
                <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 p-2">
                  <div className="card-body">
                    <div
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "-0.1px",
                        bottom: "-0.2px",
                        width: "4px",
                        backgroundColor: " rgb(33, 150, 243)",
                      }}
                    ></div>
                    <div className="row">
                      <div className="col-lg-12 col-md-5 col-5 d-flex align-items-center">
                        <div className="row text-center w-100">
                          <div className="col-12">
                            <span
                              className="nofound "
                              style={{ fontWeight: "bold" }}
                            >
                              No product subscribed
                            </span>
                          </div>
                          {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                this.state.normalData.map((element, inde) => {
                  return (
                    <div
                      className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 "
                      onClick={() =>
                        this.handleEditId(
                          element.id,
                          element.clientId,
                          element.trialExpiryDate,
                          element.subcriptionStatus,
                          element.trialStartDate,
                          element.subscriptionStartDate
                        )
                      }
                    >
                      <div className="card-body">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: element.colorCode,
                          }}
                        ></div>
                        <div className="row">
                          <div className="col-lg-3 col-md-12 col-5 col-sm-12 d-flex align-items-center">
                            <div className="row">
                              <div className="col-12">
                                <span
                                  className="reporttext14"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {element.name}
                                </span>
                              </div>
                              {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-3 col-3 col-sm-6 d-flex align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">
                                  Purchased Quantity
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.purchasedQuantity}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-3 col-3 col-sm-6 d-flex align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">
                                  Assigned License
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.assignedLicense}
                                </span>
                              </div>
                            </div>
                          </div>

                          {element.subscriptionStartDate ? (
                            <div className="col-lg-2 col-md-3 col-3 col-sm-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">
                                    Purchased Date
                                  </span>
                                </div>

                                <div className="col-12">
                                  <span className="reporttext12 ">
                                    {this.formatDate(
                                      element.subscriptionStartDate
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {element.trialStartDate &&
                          element.subcriptionStatus != "Subscribed" ? (
                            <div className="col-lg-2 col-md-3 col-sm-6 col-3 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">
                                    Trial Start Date
                                  </span>
                                </div>

                                <div className="col-12">
                                  <span className="reporttext12 ">
                                    {this.formatDate(element.trialStartDate)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="col-lg-2 col-md-3 col-3 d-flex col-sm-5 align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">Invoices</span>
                              </div>

                              <div className="col-12">
                                <span className="reporttext12 ">
                                  {element.purchasedDate}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-1 col-md-1 col-4 col-sm-1 d-flex align-items-center justify-content-end">
                            <div className="row ">
                              <CommonIcon
                                className="float-end"
                                fileName={"Arrownext"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* Cancel Subsciption */}

            <ToastContainer />

            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreen1"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilter1()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      {/* <TextField
                                                    id="jobOpTitle"
                                                    className="filter_input"
                                                    fullWidth
                                                    label="Product Name"
                                                    variant="filled"
                                                    value={this.state.choice.application}
                                                    onChange={(e) =>
                                                        this.lookupChange(e, "", "application")
                                                    }
                                                    focused
                                                /> */}
                      <Autocomplete
                        multiple
                        id="roleId"
                        className="Multiprod"
                        disablePortal
                        variant="filled"
                        options={this.state.filterProductDropdown}
                        isOptionEqualToValue={(option, value) =>
                          option.applicationId === value.applicationId
                        }
                        getOptionLabel={(option) => option.name || ""}
                        value={this.state.choice?.application || []}
                        onChange={(e, selectedValues) => {
                          const mapped = selectedValues.map((item) => ({
                            clientId: item.clientId,
                            applicationId: item.applicationId,
                            name: item.name,
                            colorCode: item.colorCode,
                          }));
                          this.lookupChange(e, mapped, "application");
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            className="filter_input Multiprod"
                            focused
                            label="Applications"
                            InputLabelProps={{
                              shrink: true, // force label to float up always
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                paddingTop: "30px", // space for label
                                alignItems: "flex-start",
                                flexWrap: "wrap",
                                minHeight: "64px",
                              },
                              "& .MuiInputLabel-root": {
                                top: "10px", // adjust label position if needed
                              },
                              "& .MuiChip-root": {
                                margin: "2px",
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20 ">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreenroles"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilterroles()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Name"
                        variant="filled"
                        value={this.state.choice.name}
                        onChange={(e) => this.lookupChange(e, "", "name")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Email"
                        variant="filled"
                        value={this.state.choice.email}
                        onChange={(e) => this.lookupChange(e, "", "email")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <Autocomplete
                        focused
                        id="roleId"
                        variant="filled"
                        disablePortal
                        value={
                          this.state.choice.type
                            ? { status: this.state.choice.type }
                            : null
                        }
                        options={[
                          { id: "1", status: "group" },
                          { id: "2", status: "user" },
                        ]}
                        getOptionLabel={(option) => option.status || ""}
                        onChange={(e, selectedValue) =>
                          this.lookupChange(e, selectedValue, "type")
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.id}>
                            {option.status}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            className="filter_input"
                            focused
                            label="Type"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearRoleFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyRoleFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>

            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="Filterscreenhistory"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilterhistory()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Action"
                        variant="filled"
                        value={this.state.choice.action}
                        onChange={(e) => this.lookupChange(e, "", "action")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Action By"
                        variant="filled"
                        value={this.state.choice.actionby}
                        onChange={(e) => this.lookupChange(e, "", "actionby")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        type="date"
                        id="jobOpOpenPositions"
                        fullWidth
                        label="Start Date"
                        className="filter_input"
                        variant="filled"
                        value={this.state.choice.startDate || ""}
                        onChange={(e) => this.lookupChange(e, "", "startdate")}
                        focused
                        disablePortal
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        type="date"
                        id="jobOpOpenPositions"
                        fullWidth
                        label="End Date"
                        className="filter_input"
                        variant="filled"
                        value={this.state.choice.endDate || ""}
                        onChange={(e) => this.lookupChange(e, "", "enddate")}
                        focused
                        disablePortal
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20">
                  <Button
                    className="btn-clear mr-10 border-none"
                    variant="outlined"
                    onClick={() => this.clearHistoryFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyHistoryFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div
              className={`modal modal-style ${
                this.state.openmemberdelete ? "show" : ""
              }`}
              id="deletemodal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{
                display: this.state.openmemberdelete ? "block" : "none",
                zIndex: "1070",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <CommonIcon fileName={"deletemember"} />
                    <br />
                    <span>Are you sure, you want to delete this user?</span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noActions()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesActions()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className="offcanvas offcanvas-end p-3 ps-3 pb-0 pt-0"
          data-bs-scroll="false"
          data-bs-backdrop
          id="AddForm2"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: this.props.menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 70px)",

            height: "100vh",
            overflowX: "auto",
          }}
        >
          {this.state.isWebMobile || this.state.isMobile ? (
            <>
              <div className="d-flex justify-content-between ps-1 pt-0">
                <h3 className="headername3 pt-3 pb-0">
                  {this.state.applicationname}
                </h3>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose float-end "
                  onClick={() => this.closeForm()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>
              <div className="mb-2 ps-1">
                <label className="pathlabel">
                  Subscriptions &gt;
                  <span className="isblue">{this.state.applicationname}</span>
                </label>
              </div>
              <div className="mobileoverflowsub">
                <div className="row ps-1">
                  <div className="col-12">
                    <h3 className="licenseheader">Trial Licenses</h3>
                  </div>
                  <div className="col-12 pt-0">
                    <div className="col-12">
                      <FormLabel className="formlabel-style1">
                        Licenses{" "}
                      </FormLabel>
                      <br />
                      <FormLabel className={`formlabel-input`}>
                        {this.state.totalLicense}
                      </FormLabel>
                    </div>
                    <div className="col-12">
                      <FormLabel className="formlabel-style1">
                        Assigned{" "}
                      </FormLabel>
                      <br />
                      <FormLabel className={`formlabel-input`}>
                        {this.state.assignedLicenses} /{" "}
                        {this.state.totalLicense}
                      </FormLabel>
                    </div>

                    <button className="btn-fun disabled ps-3 p-2 pe-3 fs-7 mt-2">
                      Assign Licenses
                    </button>
                    <button className=" disabled btn-fun ps-3 p-2 pe-3 fs-7 mt-2">
                      Start a paid subscription now
                    </button>
                  </div>
                </div>
                <hr className="hrproducts" />
                <div className="row ps-1">
                  <div className="col-12">
                    <h3 className="licenseheader">Subscription</h3>
                  </div>
                  <div className="col-12 pt-0">
                    <div className="col-12">
                      <FormLabel className="formlabel-style1">Status</FormLabel>
                      <br />
                      <FormLabel
                        className={`formlabel-input12 ${
                          this.state.subscriptionStatus == "Subscribed" ||
                          this.state.subscriptionStatus == "Trial"
                            ? "text-success"
                            : " reporttext12un"
                        } `}
                      >
                        {"Active"}
                      </FormLabel>
                    </div>
                    {!this.state.isTenantAdminCenter && (
                      <button
                        className="btn-cancel1 btn-filter-action border-none mt-0 isred ms-0 ps-0 d-flex justify-content-start"
                        onClick={this.cancelSubscription}
                      >
                        Cancel Trial
                      </button>
                    )}
                  </div>
                </div>
                <hr className="hrproducts" />
                <div className="row ps-1">
                  <div className="col-12">
                    <h3 className="licenseheader">Licensed users</h3>
                  </div>
                  <div className="col-12">
                    <div className="container-fluid">
                      <div className="row ps-1">
                        <div className="col-12 col-md-8 ps-0">
                          <Box sx={{ width: "100%", paddingLeft: 0 }}>
                            <div className="d-flex float-end mobiletab">
                              <Tabs
                                value={this.state.rolebasedId}
                                onChange={this.handleChangeTable}
                                aria-label="basic tabs example"
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                              >
                                {this.state.applicationroles.map((e) => (
                                  <Tab
                                    key={e.id}
                                    label={e.displayName}
                                    value={e.id}
                                    sx={{ textTransform: "none" }}
                                    className="m1 p0 mr-20"
                                  />
                                ))}
                              </Tabs>
                              <div className="d-none d-md-flex align-items-center ms-2">
                                <div className="d-flex align-items-center">
                                  {!this.state.search && (
                                    <button
                                      className="btn-fun ps-2 p-2 pe-2 fs-7 me-2"
                                      onClick={this.toggleWebFilterroles}
                                    >
                                      <CommonIcon fileName={"Filter"} />
                                    </button>
                                  )}
                                  {this.state.search && (
                                    <div className="border d-flex align-items-center me-2">
                                      <input
                                        type="text"
                                        className="pt-1 pb-2 border-0 outline-none p-1"
                                        value={this.state.searchInput}
                                        onChange={(e) =>
                                          this.setState({
                                            searchInput: e.target.value,
                                          })
                                        }
                                      />
                                      <span
                                        onClick={this.closesearch}
                                        className="ms-2"
                                      >
                                        <CommonIcon fileName={"close"} />
                                      </span>
                                    </div>
                                  )}
                                  {this.state.search && (
                                    <button
                                      className="btn-fun ps-3 p-2 pe-3 fs-7"
                                      onClick={this.filtersearch}
                                    >
                                      Search
                                    </button>
                                  )}
                                  {!this.state.search && (
                                    <button
                                      className="btn-fun ps-3 p-2 pe-3 fs-7 ms-2 d-flex align-items-center"
                                      onClick={this.newUserGroupFormShow}
                                    >
                                      <CommonIcon fileName={"AddPlus1"} />{" "}
                                      Assign
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Box>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 me-4 mt-2">
                    <div className="float-end d-flex me-2">
                      {!this.state.search ? (
                        <button
                          className="btn-fun ps-2 p-2 pe-2 fs-7"
                          onClick={this.toggleWebFilterroles}
                        >
                          <CommonIcon fileName={"Filter"} />
                        </button>
                      ) : (
                        ""
                      )}
                      {this.state.search ? (
                        <div className="border me-1 d-flex">
                          <input
                            type="text"
                            className=" pt-1 pb-2 border-none outlineno p-1"
                            onChange={(e) =>
                              this.setState({ searchInput: e.target.value })
                            }
                          />
                          <span onClick={this.closesearch}>
                            <CommonIcon fileName={"close"} />
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.search ? (
                        <button
                          className="btn-fun ps-3 p-2 pe-3 fs-7 "
                          onClick={this.filtersearch}
                        >
                          Search
                        </button>
                      ) : (
                        ""
                      )}
                      {!this.state.search ? (
                        <button
                          className="btn-fun ps-3 p-2 pe-3 fs-7 d-flex align-items-center"
                          onClick={this.newUserGroupFormShow}
                        >
                          <CommonIcon fileName={"AddPlus1"} /> Assign
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="row ps-2 mt-2 overflowsubmembers pe-2">
                  {!this.props.isLoading &&
                  this.state.rolebasedtableuser.length < 1 ? (
                    <div
                      className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 py-3"
                      style={{ width: "94%" }}
                    >
                      <div className="card-body">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: " rgb(33, 150, 243)",
                          }}
                        ></div>
                        <div className="row">
                          <div className="col-12 d-flex align-items-center">
                            <div className="row text-center w-100">
                              <div className="col-12">
                                <span
                                  className="nofound "
                                  style={{ fontWeight: "bold" }}
                                >
                                  No records found
                                </span>
                              </div>
                              {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    this.state.rolebasedtableuser.map((element) => {
                      console.log(element);

                      return (
                        <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 py-3">
                          <div className="card-body pt-0 pb-0">
                            <div
                              style={{
                                position: "absolute",
                                left: "0",
                                top: "-0.1px",
                                bottom: "-0.2px",
                                width: "4px",
                                backgroundColor: " rgb(33, 150, 243)",
                              }}
                            ></div>
                            <div className="row">
                              <div className="col-12 d-flex align-items-center mb-1">
                                <div className="row">
                                  <div className="col-12 d-flex align-items-center">
                                    <span
                                      className="reporttext14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {element.name}
                                    </span>
                                    {/* {element.isPrimaryEmail && (
                                      <span className="badge-fun">
                                        Super Admin
                                      </span>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">Email</span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12">
                                      {element.email}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 d-flex align-items-center justify-content-end ">
                                <span
                                  className={`cursor-pointer float-end ${
                                    element.isPrimaryEmail ? "d-none" : ""
                                  }`}
                                  onClick={() => this.handleDelete(element)}
                                >
                                  <CommonIcon fileName={"DeleteIcon"} />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-between ps-1 pt-0">
                <h3 className="headername3 pt-3">
                  {this.state.applicationname}
                  {!this.state.isTenantAdminCenter && " - Trial"}
                </h3>
                {/* <h3 className='headername3 pt-3'>Basic Plan</h3> */}
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose float-end "
                  onClick={() => this.closeForm()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>
              <div className="row ps-1">
                <div className="col-4 col-md-4 col-xl-2 col-lg-3">
                  <h3 className="licenseheader">Trial Licenses</h3>
                </div>
                <div className="col-8 col-xl-10 col-lg-9 col-md-8 pt-0">
                  <div className="col-12">
                    <div className="d-flex align-items-start">
                      <FormLabel className="formlabel-style1">
                        Licenses{" "}
                      </FormLabel>
                      <span className={`formlabel-input`}>
                        &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;
                        {this.state.totalLicense}
                      </span>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex align-items-start">
                      <FormLabel className="formlabel-style1">
                        Assigned{" "}
                      </FormLabel>
                      <span className={`formlabel-input`}>
                        &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;
                        {this.state.assignedLicenses} /{" "}
                        {this.state.totalLicense}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex">
                    <button className="btn-fun disabled ps-3 p-2 pe-3 fs-7 mt-2">
                      Assign Licenses
                    </button>
                    <button className="disabled btn-fun ps-3 p-2 pe-3 fs-7 mt-2">
                      Start a paid subscription now
                    </button>
                  </div>
                </div>
              </div>
              <hr className="hrproducts" />
              <div className="row ps-1">
                <div className="col-4 col-md-4 col-xl-2 col-lg-3">
                  <h3 className="licenseheader">Subscription</h3>
                </div>
                <div className="col-8 col-xl-10 col-lg-9 col-md-8 pt-0">
                  <div className="col-12 mb-0">
                    <div className="d-flex align-items-start">
                      <FormLabel className="formlabel-style1">Status</FormLabel>
                      <FormLabel className="px-2">-</FormLabel>
                      <span
                        className={`formlabel-input12 ${
                          this.state.subscriptionStatus == "Subscribed" ||
                          this.state.subscriptionStatus == "Trial"
                            ? "text-success"
                            : " reporttext12un"
                        } `}
                      >
                        {"Active"}
                      </span>
                    </div>
                  </div>
                  <div>
                    {!this.state.isTenantAdminCenter && (
                      <button
                        className="pt-0 pb-0 btn-cancel1 btn-filter-action border-none mt-0 isred ms-0 ps-0 d-flex justify-content-start"
                        onClick={this.cancelSubscription}
                      >
                        Cancel Trial
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <hr className="hrproducts mb-1" />
              <div className="container-fluid">
                <div className="row ps-1 d-flex align-items-center">
                  <div className="col-12 ps-0 ms-0 col-md-4 col-xl-2 col-lg-3 mb-3 mb-md-0">
                    <h3 className="licenseheader mt-2">Licensed users</h3>
                  </div>
                  <div className="col-12 col-md-8 col-xl-10 col-lg-9 ps-1 pe-0 mt-0 pt-0">
                    <Box sx={{ width: "100%", padding: 0 }}>
                      <div className="d-flex justify-content-between ">
                        <Tabs
                          value={this.state.rolebasedId}
                          onChange={this.handleChangeTable}
                          aria-label="basic tabs example"
                          variant="scrollable"
                          scrollButtons="auto"
                          allowScrollButtonsMobile
                        >
                          {this.state.applicationroles.map((e) => (
                            <Tab
                              key={e.id}
                              label={e.displayName}
                              value={e.id}
                              sx={{ textTransform: "none" }}
                              className="m1 p0 mr-20"
                            />
                          ))}
                        </Tabs>
                        <div className="d-none d-md-flex align-items-center ms-2">
                          <div className="d-flex align-items-center">
                            {this.state.search && (
                              <div className="border d-flex align-items-center me-2">
                                <input
                                  type="text"
                                  style={{ width: "125px" }}
                                  className="pt-1 pb-2 border-0 outline-none p-1"
                                  value={this.state.searchInput}
                                  onChange={(e) =>
                                    this.setState({
                                      searchInput: e.target.value,
                                    })
                                  }
                                />
                                <span
                                  onClick={this.closesearch}
                                  className="ms-2"
                                >
                                  <CommonIcon fileName={"close"} />
                                </span>
                              </div>
                            )}
                            {this.state.search && (
                              <button
                                className="btn-fun ps-3 p-2 pe-3 fs-7"
                                onClick={this.filtersearch}
                              >
                                Search
                              </button>
                            )}
                            {!this.state.search && (
                              <button
                                className="btn-fun ps-3 p-2 pe-3 fs-7 ms-2 me-0 d-flex align-items-center"
                                onClick={this.newUserGroupFormShow}
                              >
                                <CommonIcon fileName={"AddPlus1"} />
                                Assign
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Box>
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-4 col-xl-2 col-lg-3 col-md-4"></div>
                <div className="col-8 col-xl-10 col-lg-9 col-md-8">
                  {document
                    .getElementById("AddForm2")
                    ?.classList.contains("show") && (
                    <CustomListViewSub
                      listData={this.state.rolebasedtableuser}
                      columns={this.state.columns}
                      handleDataFetch={this.handleDataFetch}
                      totalCount={this.state.totalCount}
                      isLoading={this.state.tableLoader}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className={`${
            this.state.isCancelScreenOpen ? "show" : ""
          } offcanvas offcanvas-end`}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="cancelsubscription"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: this.props.menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 70px)",
            height: "100vh",
          }}
        >
          {this.state.isCancelScreenOpen && (
            <CancelSubscription
              appDetails={this.state.appDetails}
              closeForm={this.closeFormCancel}
              cancelTrial={this.cancelTrial}
              cancellationReason={this.state.cancellationReason}
              cancellationMessage={this.state.cancelMessage}
            />
          )}
        </div>
        {/* <Offcanvas
                    show={this.state.isCancelScreenOpen}
                    onHide={this.closeFormCancel}
                    placement="end"
                    style={{
                        width: "calc(100% - 241px)",
                        height: "100vh",
                    }}
                    backdrop={true}
                    scroll={false}
                    id="cancelsubscription"
                    aria-labelledby="offcanvasScrollingLabel"
                >
                    <Offcanvas.Body className='p-0'>
                        {this.state.isCancelScreenOpen &&
                            <CancelSubscription closeForm={this.closeFormCancel} />
                        }
                    </Offcanvas.Body>
                </Offcanvas> */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="true"
          id="AddGrouporrole"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: this.state.isWebMobile || this.state.isMobile ? "" : "50.7%",
          }}
        >
          {this.state.isWebMobile || this.state.isMobile ? (
            <>
              <div
                className={`offcanvas-header d-flex align-items-center  pe-4 pt-2`}
              >
                <span className="headername3 px-3">Assign User</span>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose"
                  onClick={() => {
                    this.closeUserGroupForm();
                    this.closeFormRole();
                  }}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div
                className="offcanvas-body pt-0"
                style={{ overflow: "hidden" }}
              >
                {this.state.availableLicense > 0 ? (
                  <>
                    <div className="row " style={{ padding: "0rem 1rem" }}>
                      <div className="col-12  flex-1">
                        <FormLabel className="formlabel-style1">
                          {/* Assign user */}User
                        </FormLabel>
                        <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 ps-0">
                          <Autocomplete
                            className="col-12"
                            error={this.state.userError}
                            id="autocom"
                            multiple // Enable multi-select
                            options={this.state.unAssigned}
                            getOptionLabel={(option) =>
                              `${option.email ? option.email : option.name}`
                            }
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "12px",
                                }}
                              >
                                <Avatar
                                  sx={{ width: 35, height: 35, marginRight: 2 }}
                                >
                                  {option.name.charAt(0)}
                                </Avatar>
                                <div>
                                  <strong>{option.name}</strong>
                                  <div>{option.email}</div>
                                </div>
                              </li>
                            )}
                            value={this.state.selectedUserssss} // Changed from `selectedUser` to `selectedUsers` to support multiple selections
                            onChange={this.handleUserChange}
                            renderInput={(params) => (
                              <div className="d-flex">
                                <TextField
                                  error={this.state.userError}
                                  helperText={
                                    this.state.userError
                                      ? "Please select a user"
                                      : ""
                                  }
                                  className="addadmininput"
                                  id="textin"
                                  {...params}
                                  variant="filled"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: null, // Removes the dropdown arrow
                                    sx: {
                                      height: "max-content",
                                      "& .MuiAutocomplete-popupIndicator": {
                                        display: "none", // Ensure any popup indicator is hidden
                                      },
                                    },
                                    inputProps: {
                                      ...params.inputProps,
                                      style: {
                                        padding: 0,
                                        height: "100%",
                                        display: "flex",
                                        paddingBottom: "20px",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            )}
                            sx={{ width: "100%", marginRight: 2 }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3" style={{ padding: "0rem 1rem" }}>
                      <div className="col-12">
                        <FormControl fullWidth sx={{ width: "100%" }}>
                          <FormLabel className="formlabel-style1">
                            Select a role
                          </FormLabel>
                          {/* <Select
                            id="dropdown"
                            value={this.state.rolebasedId}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedRole =
                                this.state.applicationroles.find(
                                  (role) => role.id === selectedId
                                );

                              this.setState({
                                rolebasedId: selectedId,
                                selectedteam:
                                  selectedRole?.name === "Admin"
                                    ? null
                                    : this.state.selectedteam,
                              });
                            }}
                            label="Select Option"
                            variant="filled"
                            sx={{
                              "& .MuiSelect-select": {
                                padding: "10px 14px", // Adjust padding as needed
                                backgroundColor: "white",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", // Remove the border
                              },
                              "& .MuiSelect-icon": {
                                color: "inherit", // Adjust icon color if needed
                              },
                              "&:before": {
                                borderBottom: "none", // Remove the underline
                              },
                              "&:after": {
                                borderBottom: "none", // Remove the underline on focus
                              },
                            }}
                          >
                            {this.state.applicationroles.map((e) => {
                              return (
                                <MenuItem
                                  value={String(e.id)}
                                  sx={{
                                    backgroundColor: "white",
                                  }}
                                >
                                  {e.name}
                                </MenuItem>
                              );
                            })}
                          </Select> */}
                          {isRadio && (
                            <RadioGroup
                              row
                              value={this.state.temprolebasedId}
                              onChange={(e) =>
                                this.handleRoleSelect(e.target.value)
                              }
                            >
                              {this.state.applicationroles.map((role) => (
                                <FormControlLabel
                                  key={role.id}
                                  value={role.id}
                                  control={<Radio />}
                                  label={role.name}
                                />
                              ))}
                            </RadioGroup>
                          )}
                          {!isRadio && (
                            <FormGroup row>
                              {this.state.applicationroles.map((role) => {
                                const isChecked =
                                  this.state.selectedRoleCheck.includes(
                                    role.name
                                  );
                                const isLastChecked =
                                  isChecked &&
                                  this.state.selectedRoleCheck.length === 1;

                                return (
                                  <FormControlLabel
                                    key={role.id}
                                    label={role.name}
                                    control={
                                      <Checkbox
                                        checked={isChecked}
                                        // disabled={isLastChecked}
                                        onChange={(e) => {
                                          let updatedIds = [
                                            ...this.state.selectedRoleCheck,
                                          ];

                                          if (e.target.checked) {
                                            updatedIds.push(role.name);
                                          } else {
                                            updatedIds = updatedIds.filter(
                                              (name) => name !== role.name
                                            );
                                          }
                                          if (!isLastChecked) {
                                            this.setState({
                                              selectedRoleCheck: updatedIds,
                                            });
                                          }
                                        }}
                                      />
                                    }
                                  />
                                );
                              })}
                            </FormGroup>
                          )}

                          {/* <FormGroup
                            row
                            value={this.state.temprolebasedId}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              console.log(e.target.value);

                              const selectedRole =
                                this.state.applicationroles.find(
                                  (role) => role.id === selectedId
                                );

                              this.setState({
                                temprolebasedId: selectedId,
                                selectedteam:
                                  selectedRole?.name === "Admin"
                                    ? null
                                    : this.state.selectedteam,
                                rolename: selectedRole.name,
                              });
                            }}
                          >
                            {this.state.applicationroles.map((role) => (
                              <FormControlLabel
                                key={role.id}
                                value={role.id}
                                control={<Checkbox />}
                                label={role.name}
                                sx={{
                                  marginLeft: 0,
                                  marginRight: 0, // removes extra left margin
                                  paddingLeft: 0, // removes left padding
                                  ".MuiRadio-root": {
                                    padding: 1,
                                    marginLeft: -1,
                                  },
                                }}
                              />
                            ))}
                          </FormGroup> */}
                        </FormControl>
                      </div>
                    </div>
                    {/* {this.state.applicationroles.find(
                      (role) => role.id === this.state.rolebasedId
                    )?.name != "Admin" && (
                      <div
                        className="row mt-3"
                        style={{ padding: "0rem 1rem" }}
                      >
                        <div className="col-12  flex-1">
                          <FormLabel className="formlabel-style1">
                            Team
                          </FormLabel>
                          <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 ps-0">
                            <Autocomplete
                              className="col-12"
                              id="autocom"
                              error={this.state.teamError}
                              options={this.state.teamsData}
                              getOptionLabel={(option) => `${option.teamName}`}
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  {option.teamName}
                                </li>
                              )}
                              value={this.state.selectedteam ?? null} // Changed from `selectedUser` to `selectedUsers` to support multiple selections
                              onChange={(event, newValue) =>
                                this.setState({ selectedteam: newValue })
                              }
                              renderInput={(params) => (
                                <div className="d-flex">
                                  <TextField
                                    error={this.state.teamError}
                                    helperText={
                                      this.state.teamError
                                        ? "please select a team"
                                        : ""
                                    }
                                    className="addadmininput"
                                    id="textin"
                                    {...params}
                                    variant="filled"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: null, // Removes the dropdown arrow
                                      sx: {
                                        height: "max-content",
                                        "& .MuiAutocomplete-popupIndicator": {
                                          display: "none", // Ensure any popup indicator is hidden
                                        },
                                      },
                                      inputProps: {
                                        ...params.inputProps,
                                        style: {
                                          padding: 0,
                                          height: "100%",
                                          display: "flex",
                                          paddingBottom: "20px",
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              )}
                              sx={{ width: "100%", marginRight: 2 }}
                            />
                          </div>
                        </div>
                      </div>
                    )} */}

                    {/* <p class="ml-12" /> */}
                    <div className="row mt-1">
                      <div className="col-12 mt-1 pb-20 pr-28 ml-19 ps-2">
                        <button
                          onClick={this.savetable}
                          className="btn-fun ps-4 pe-4 fs-7"
                        >
                          Assign User
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                  </>
                ) : (
                  <div>
                    <h3 className="nolicensewarning ps-3">
                      No license available. Please increase required licenses to
                      add new users.
                    </h3>
                  </div>
                )}

                <div>
                  <div className={`col-12 `}></div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className={`offcanvas-header d-flex align-items-center  pe-4 pt-2`}
              >
                <span className="headername3 px-3">Assign User</span>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose"
                  onClick={() => {
                    this.closeUserGroupForm();
                    this.closeFormRole();
                  }}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div
                className="offcanvas-body pt-0"
                style={{ overflow: "hidden" }}
              >
                {this.state.availableLicense > 0 ? (
                  <>
                    <div className="row" style={{ padding: "0rem 1rem" }}>
                      <div className="col-12  flex-1">
                        <FormLabel className="formlabel-style1">
                          {/* Assign user */}User
                        </FormLabel>
                        <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 ps-0">
                          <Autocomplete
                            className="col-12"
                            error={this.state.userError}
                            id="autocom"
                            multiple // Enable multi-select
                            options={this.state.unAssigned}
                            getOptionLabel={(option) =>
                              `${option.email ? option.email : option.name}`
                            }
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "12px",
                                }}
                              >
                                <Avatar
                                  sx={{ width: 35, height: 35, marginRight: 2 }}
                                >
                                  {option.name.charAt(0)}
                                </Avatar>
                                <div>
                                  <strong>{option.name}</strong>
                                  <div>{option.email}</div>
                                </div>
                              </li>
                            )}
                            value={this.state.selectedUserssss} // Changed from `selectedUser` to `selectedUsers` to support multiple selections
                            onChange={this.handleUserChange}
                            renderInput={(params) => (
                              <div className="d-flex">
                                <TextField
                                  error={this.state.userError}
                                  helperText={
                                    this.state.userError
                                      ? "Please select a user"
                                      : ""
                                  }
                                  className="addadmininput"
                                  id="textin"
                                  {...params}
                                  variant="filled"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: null, // Removes the dropdown arrow
                                    sx: {
                                      height: "max-content",
                                      "& .MuiAutocomplete-popupIndicator": {
                                        display: "none", // Ensure any popup indicator is hidden
                                      },
                                    },
                                    inputProps: {
                                      ...params.inputProps,
                                      style: {
                                        padding: 0,
                                        height: "100%",
                                        display: "flex",
                                        paddingBottom: "20px",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            )}
                            sx={{ width: "100%", marginRight: 2 }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3" style={{ padding: "0rem 1rem" }}>
                      <div className="col-12">
                        <FormControl fullWidth sx={{ width: "100%" }}>
                          <FormLabel className="formlabel-style1">
                            Select a role
                          </FormLabel>
                          {isRadio && (
                            <RadioGroup
                              row
                              value={this.state.temprolebasedId}
                              onChange={(e) =>
                                this.handleRoleSelect(e.target.value)
                              }
                            >
                              {this.state.applicationroles.map((role) => (
                                <FormControlLabel
                                  key={role.id}
                                  value={role.id}
                                  control={<Radio />}
                                  label={role.name}
                                />
                              ))}
                            </RadioGroup>
                          )}
                          {!isRadio && (
                            <FormGroup row>
                              {this.state.applicationroles.map((role) => {
                                const isChecked =
                                  this.state.selectedRoleCheck.includes(
                                    role.name
                                  );
                                const isLastChecked =
                                  isChecked &&
                                  this.state.selectedRoleCheck.length === 1;

                                return (
                                  <FormControlLabel
                                    key={role.id}
                                    label={role.name}
                                    control={
                                      <Checkbox
                                        checked={isChecked}
                                        // disabled={isLastChecked}
                                        onChange={(e) => {
                                          let updatedIds = [
                                            ...this.state.selectedRoleCheck,
                                          ];

                                          if (e.target.checked) {
                                            updatedIds.push(role.name);
                                          } else {
                                            updatedIds = updatedIds.filter(
                                              (name) => name !== role.name
                                            );
                                          }
                                          if (!isLastChecked) {
                                            this.setState({
                                              selectedRoleCheck: updatedIds,
                                            });
                                          }
                                        }}
                                      />
                                    }
                                  />
                                );
                              })}
                            </FormGroup>
                          )}
                        </FormControl>
                      </div>
                    </div>
                    {/* {this.state.applicationroles.find(
                      (role) => role.id === this.state.rolebasedId
                    )?.name != "Admin" && (
                      <div
                        className="row mt-3"
                        style={{ padding: "0rem 1rem" }}
                      >
                        <div className="col-12  flex-1">
                          <FormLabel className="formlabel-style1">
                            Team
                          </FormLabel>
                          <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 ps-0">
                            <Autocomplete
                              className="col-12"
                              error={this.state.teamError}
                              id="autocom"
                              options={this.state.teamsData}
                              getOptionLabel={(option) => `${option.teamName}`}
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  {option.teamName}
                                </li>
                              )}
                              value={this.state.selectedteam ?? null} // Changed from `selectedUser` to `selectedUsers` to support multiple selections
                              onChange={(event, newValue) =>
                                this.setState({ selectedteam: newValue })
                              }
                              renderInput={(params) => (
                                <div className="d-flex">
                                  <TextField
                                    error={this.state.teamError}
                                    helperText={
                                      this.state.teamError
                                        ? "please select a team"
                                        : ""
                                    }
                                    className="addadmininput"
                                    id="textin"
                                    {...params}
                                    variant="filled"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: null, // Removes the dropdown arrow
                                      sx: {
                                        height: "max-content",
                                        "& .MuiAutocomplete-popupIndicator": {
                                          display: "none", // Ensure any popup indicator is hidden
                                        },
                                      },
                                      inputProps: {
                                        ...params.inputProps,
                                        style: {
                                          padding: 0,
                                          height: "100%",
                                          display: "flex",
                                          paddingBottom: "20px",
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              )}
                              sx={{ width: "100%", marginRight: 2 }}
                            />
                          </div>
                        </div>
                      </div>
                    )} */}

                    {/* <p class="ml-12" /> */}
                    <div className="row mt-1">
                      <div className="col-12 mt-1 pb-20 pr-28 ml-19 ps-2">
                        <button
                          onClick={this.savetable}
                          className="btn-fun ps-4 pe-4 fs-7"
                        >
                          Assign User
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                  </>
                ) : (
                  <div>
                    <h3 className="nolicensewarning ps-3">
                      No license available. Please increase required licenses to
                      add new users.
                    </h3>
                  </div>
                )}

                <div>
                  <div className={`col-12 `}></div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    // sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};

function mapStateToProps(state) {
  return {
    getapplication: state.applicationReducer.getapplication,
    getApplicationLicenseStatus:
      state.applicationReducer.getApplicationLicenseStatus,
    getApplicationUsers: state.applicationReducer.getApplicationUsers,
    auditLog: state.applicationReducer.auditLog,
    userRoleAssign: state.applicationReducer.userRoleAssign,
    isLoading: state.commonReducer.isLoading,
    menuToggle: state.SideBarReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(subscription)
);
